/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as HomeRouteImport } from './routes/_home'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as SuperRouteImport } from './routes/_super'
import { Route as AuthenticatedClientsRouteImport } from './routes/_authenticated/clients'
import { Route as AuthenticatedCollectionsRouteImport } from './routes/_authenticated/collections'
import { Route as AuthenticatedCompleteProfileRouteImport } from './routes/_authenticated/complete-profile'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedDocumentsRouteImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedInvoicesRouteImport } from './routes/_authenticated/invoices'
import { Route as AuthenticatedOperationsRouteImport } from './routes/_authenticated/operations'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedQuotationsRouteImport } from './routes/_authenticated/quotations'
import { Route as AuthenticatedReleaseNotesRouteImport } from './routes/_authenticated/release-notes'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedSalesRouteImport } from './routes/_authenticated/sales'
import { Route as AuthenticatedSubscriptionSuccessRouteImport } from './routes/_authenticated/subscription-success'
import { Route as AuthenticatedSubscriptionsRouteImport } from './routes/_authenticated/subscriptions'
import { Route as AuthenticatedSuppliersRouteImport } from './routes/_authenticated/suppliers'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as HomeWaitlistRouteImport } from './routes/_home/waitlist'
import { Route as PublicActivateRouteImport } from './routes/_public/activate'
import { Route as PublicLicensesRouteImport } from './routes/_public/licenses'
import { Route as PublicSetupRouteImport } from './routes/_public/setup'
import { Route as AuthenticatedDevCrdtPlaygroundRouteImport } from './routes/_authenticated/_dev/crdt-playground'
import { Route as AuthenticatedAiLayoutRouteImport } from './routes/_authenticated/ai/_layout'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedCollectionsCollectionIdRouteImport } from './routes/_authenticated/collections/$collectionId'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedInventoryCountsIndexRouteImport } from './routes/_authenticated/inventory-counts/index'
import { Route as AuthenticatedInventoryCountsNewRouteImport } from './routes/_authenticated/inventory-counts/new'
import { Route as AuthenticatedInventoryIndexRouteImport } from './routes/_authenticated/inventory/index'
import { Route as AuthenticatedInventoryMovementsRouteImport } from './routes/_authenticated/inventory/movements'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices/index'
import { Route as AuthenticatedInvoicesNewRouteImport } from './routes/_authenticated/invoices/new'
import { Route as AuthenticatedOperationsPersonnelRolesRouteImport } from './routes/_authenticated/operations/personnel-roles'
import { Route as AuthenticatedProductsLayoutRouteImport } from './routes/_authenticated/products/_layout'
import { Route as AuthenticatedPurchaseOrdersIndexRouteImport } from './routes/_authenticated/purchase-orders/index'
import { Route as AuthenticatedPurchaseOrdersNewRouteImport } from './routes/_authenticated/purchase-orders/new'
import { Route as AuthenticatedQuotationsIndexRouteImport } from './routes/_authenticated/quotations/index'
import { Route as AuthenticatedQuotationsNewRouteImport } from './routes/_authenticated/quotations/new'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedSalesIndexRouteImport } from './routes/_authenticated/sales/index'
import { Route as AuthenticatedSalesNewRouteImport } from './routes/_authenticated/sales/new'
import { Route as AuthenticatedServicesLayoutRouteImport } from './routes/_authenticated/services/_layout'
import { Route as AuthenticatedSettingsLayoutRouteImport } from './routes/_authenticated/settings/_layout'
import { Route as AuthenticatedStockTransfersIndexRouteImport } from './routes/_authenticated/stock-transfers/index'
import { Route as AuthenticatedStockTransfersNewRouteImport } from './routes/_authenticated/stock-transfers/new'
import { Route as AuthenticatedSuppliersIndexRouteImport } from './routes/_authenticated/suppliers/index'
import { Route as PublicAuthFirstTimeLoginRouteImport } from './routes/_public/auth/first-time-login'
import { Route as PublicAuthResetPasswordRouteImport } from './routes/_public/auth/reset-password'
import { Route as PublicAuthSignInRouteImport } from './routes/_public/auth/sign-in'
import { Route as PublicAuthSignInWithOtpRouteImport } from './routes/_public/auth/sign-in-with-otp'
import { Route as PublicAuthSignUpRouteImport } from './routes/_public/auth/sign-up'
import { Route as SuperSuperLayoutRouteImport } from './routes/_super/super/_layout'
import { Route as SuperSuperCompaniesRouteImport } from './routes/_super/super/companies'
import { Route as SuperSuperDashboardRouteImport } from './routes/_super/super/dashboard'
import { Route as SuperSuperLicensesRouteImport } from './routes/_super/super/licenses'
import { Route as SuperSuperPlansRouteImport } from './routes/_super/super/plans'
import { Route as SuperSuperReleasesRouteImport } from './routes/_super/super/releases'
import { Route as SuperSuperSubscriptionsRouteImport } from './routes/_super/super/subscriptions'
import { Route as SuperSuperUsersRouteImport } from './routes/_super/super/users'
import { Route as SuperSuperWaitlistRouteImport } from './routes/_super/super/waitlist'
import { Route as AuthenticatedAiLayoutIndexRouteImport } from './routes/_authenticated/ai/_layout/index'
import { Route as AuthenticatedAiLayoutInsightsRouteImport } from './routes/_authenticated/ai/_layout/insights'
import { Route as AuthenticatedCollectionsCollectionIdIndexRouteImport } from './routes/_authenticated/collections/$collectionId/index'
import { Route as AuthenticatedCollectionsCollectionIdCalendarRouteImport } from './routes/_authenticated/collections/$collectionId/calendar'
import { Route as AuthenticatedCollectionsCollectionIdKanbanRouteImport } from './routes/_authenticated/collections/$collectionId/kanban'
import { Route as AuthenticatedCollectionsCollectionIdTableRouteImport } from './routes/_authenticated/collections/$collectionId/table'
import { Route as AuthenticatedDocumentsTemplatesNewRouteImport } from './routes/_authenticated/documents/templates/new'
import { Route as AuthenticatedInventoryCountsIdEditRouteImport } from './routes/_authenticated/inventory-counts/$id.edit'
import { Route as AuthenticatedInvoicesIdEditRouteImport } from './routes/_authenticated/invoices/$id.edit'
import { Route as AuthenticatedInvoicesCancelationsIndexRouteImport } from './routes/_authenticated/invoices/cancelations/index'
import { Route as AuthenticatedInvoicesCreditNotesIndexRouteImport } from './routes/_authenticated/invoices/credit-notes/index'
import { Route as AuthenticatedInvoicesCreditNotesNewRouteImport } from './routes/_authenticated/invoices/credit-notes/new'
import { Route as AuthenticatedInvoicesCreditsIndexRouteImport } from './routes/_authenticated/invoices/credits/index'
import { Route as AuthenticatedInvoicesDebitNotesIndexRouteImport } from './routes/_authenticated/invoices/debit-notes/index'
import { Route as AuthenticatedInvoicesDebitNotesNewRouteImport } from './routes/_authenticated/invoices/debit-notes/new'
import { Route as AuthenticatedInvoicesExemptionsIndexRouteImport } from './routes/_authenticated/invoices/exemptions/index'
import { Route as AuthenticatedInvoicesPaymentsIndexRouteImport } from './routes/_authenticated/invoices/payments/index'
import { Route as AuthenticatedOperationsEquipmentIndexRouteImport } from './routes/_authenticated/operations/equipment/index'
import { Route as AuthenticatedOperationsPersonnelIndexRouteImport } from './routes/_authenticated/operations/personnel/index'
import { Route as AuthenticatedOperationsWorkOrdersIdRouteImport } from './routes/_authenticated/operations/work-orders/$id'
import { Route as AuthenticatedOperationsWorkOrdersListRouteImport } from './routes/_authenticated/operations/work-orders/_list'
import { Route as AuthenticatedProductsLayoutIndexRouteImport } from './routes/_authenticated/products/_layout/index'
import { Route as AuthenticatedProductsLayoutNewRouteImport } from './routes/_authenticated/products/_layout/new'
import { Route as AuthenticatedPurchaseOrdersIdEditRouteImport } from './routes/_authenticated/purchase-orders/$id.edit'
import { Route as AuthenticatedQuotationsCodeEditRouteImport } from './routes/_authenticated/quotations/$code.edit'
import { Route as AuthenticatedReportsIdBuilderRouteImport } from './routes/_authenticated/reports/$id.builder'
import { Route as AuthenticatedSalesIdEditRouteImport } from './routes/_authenticated/sales/$id.edit'
import { Route as AuthenticatedSalesSellersIndexRouteImport } from './routes/_authenticated/sales/sellers/index'
import { Route as AuthenticatedServicesLayoutIndexRouteImport } from './routes/_authenticated/services/_layout/index'
import { Route as AuthenticatedServicesLayoutNewRouteImport } from './routes/_authenticated/services/_layout/new'
import { Route as AuthenticatedSettingsLayoutIndexRouteImport } from './routes/_authenticated/settings/_layout/index'
import { Route as AuthenticatedSettingsLayoutAiRouteImport } from './routes/_authenticated/settings/_layout/ai'
import { Route as AuthenticatedSettingsLayoutBranchesRouteImport } from './routes/_authenticated/settings/_layout/branches'
import { Route as AuthenticatedSettingsLayoutCatalogsRouteImport } from './routes/_authenticated/settings/_layout/catalogs'
import { Route as AuthenticatedSettingsLayoutCompaniesRouteImport } from './routes/_authenticated/settings/_layout/companies'
import { Route as AuthenticatedSettingsLayoutCorrelativesRouteImport } from './routes/_authenticated/settings/_layout/correlatives'
import { Route as AuthenticatedSettingsLayoutMigrationsRouteImport } from './routes/_authenticated/settings/_layout/migrations'
import { Route as AuthenticatedSettingsLayoutNomenclaturesRouteImport } from './routes/_authenticated/settings/_layout/nomenclatures'
import { Route as AuthenticatedSettingsLayoutNotificationsRouteImport } from './routes/_authenticated/settings/_layout/notifications'
import { Route as AuthenticatedSettingsLayoutRolesRouteImport } from './routes/_authenticated/settings/_layout/roles'
import { Route as AuthenticatedSettingsLayoutSchemaRouteImport } from './routes/_authenticated/settings/_layout/schema'
import { Route as AuthenticatedSettingsLayoutSecurityRouteImport } from './routes/_authenticated/settings/_layout/security'
import { Route as AuthenticatedSettingsLayoutSubscriptionRouteImport } from './routes/_authenticated/settings/_layout/subscription'
import { Route as AuthenticatedSettingsLayoutTrashRouteImport } from './routes/_authenticated/settings/_layout/trash'
import { Route as AuthenticatedSettingsLayoutUsersRouteImport } from './routes/_authenticated/settings/_layout/users'
import { Route as AuthenticatedSettingsLayoutWarehousesRouteImport } from './routes/_authenticated/settings/_layout/warehouses'
import { Route as AuthenticatedStockTransfersIdEditRouteImport } from './routes/_authenticated/stock-transfers/$id.edit'
import { Route as PublicSSlugIndexRouteImport } from './routes/_public/s/$slug/index'
import { Route as PublicSSlugPageRouteImport } from './routes/_public/s/$slug/$page'
import { Route as PublicSharedDashboardsTokenRouteImport } from './routes/_public/shared/dashboards/$token'
import { Route as PublicSharedInvoicesIdRouteImport } from './routes/_public/shared/invoices/$id'
import { Route as PublicSharedQuotationsIdRouteImport } from './routes/_public/shared/quotations/$id'
import { Route as PublicSharedSalesIdRouteImport } from './routes/_public/shared/sales/$id'
import { Route as SuperSuperAppsIndexRouteImport } from './routes/_super/super/apps.index'
import { Route as SuperSuperAppsVersionIdRouteImport } from './routes/_super/super/apps.$versionId'
import { Route as SuperSuperControlPanelCompanyIdRouteImport } from './routes/_super/super/control-panel.$companyId'
import { Route as AuthenticatedCollectionsCollectionIdRecordsRecordIdRouteImport } from './routes/_authenticated/collections/$collectionId/records/$recordId'
import { Route as AuthenticatedCollectionsCollectionIdRecordsNewRouteImport } from './routes/_authenticated/collections/$collectionId/records/new'
import { Route as AuthenticatedDocumentsRecordsIdEditRouteImport } from './routes/_authenticated/documents/records/$id/edit'
import { Route as AuthenticatedDocumentsTemplatesIdEditRouteImport } from './routes/_authenticated/documents/templates/$id/edit'
import { Route as AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRouteImport } from './routes/_authenticated/invoices/credit-notes/$creditNoteId/index'
import { Route as AuthenticatedInvoicesCreditNotesCreditNoteIdEditRouteImport } from './routes/_authenticated/invoices/credit-notes/$creditNoteId.edit'
import { Route as AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRouteImport } from './routes/_authenticated/invoices/debit-notes/$debitNoteId/index'
import { Route as AuthenticatedInvoicesDebitNotesDebitNoteIdEditRouteImport } from './routes/_authenticated/invoices/debit-notes/$debitNoteId.edit'
import { Route as AuthenticatedOperationsWorkOrdersListIndexRouteImport } from './routes/_authenticated/operations/work-orders/_list/index'
import { Route as AuthenticatedOperationsWorkOrdersListCalendarRouteImport } from './routes/_authenticated/operations/work-orders/_list/calendar'
import { Route as AuthenticatedOperationsWorkOrdersListMineRouteImport } from './routes/_authenticated/operations/work-orders/_list/mine'
import { Route as AuthenticatedOperationsWorkOrdersListTableRouteImport } from './routes/_authenticated/operations/work-orders/_list/table'
import { Route as AuthenticatedOperationsWorkOrdersListWeekRouteImport } from './routes/_authenticated/operations/work-orders/_list/week'
import { Route as AuthenticatedProductsLayoutIdEditRouteImport } from './routes/_authenticated/products/_layout/$id.edit'
import { Route as AuthenticatedServicesLayoutIdEditRouteImport } from './routes/_authenticated/services/_layout/$id.edit'
import { Route as AuthenticatedSettingsLayoutAgentsIndexRouteImport } from './routes/_authenticated/settings/_layout/agents/index'
import { Route as AuthenticatedSettingsLayoutAppsIndexRouteImport } from './routes/_authenticated/settings/_layout/apps/index'
import { Route as AuthenticatedSettingsLayoutAppsListingIdRouteImport } from './routes/_authenticated/settings/_layout/apps/$listingId'
import { Route as AuthenticatedSettingsLayoutAppsPublishRouteImport } from './routes/_authenticated/settings/_layout/apps/publish'
import { Route as AuthenticatedSettingsLayoutCollectionsIndexRouteImport } from './routes/_authenticated/settings/_layout/collections/index'
import { Route as AuthenticatedSettingsLayoutCollectionsSchemaRouteImport } from './routes/_authenticated/settings/_layout/collections/schema'
import { Route as AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRouteImport } from './routes/_authenticated/settings/_layout/email-templates/$templateId'
import { Route as AuthenticatedSettingsLayoutIntegrationsIndexRouteImport } from './routes/_authenticated/settings/_layout/integrations/index'
import { Route as AuthenticatedSettingsLayoutIntegrationsConnectionIdRouteImport } from './routes/_authenticated/settings/_layout/integrations/$connectionId'
import { Route as AuthenticatedSettingsLayoutInventoryIndexRouteImport } from './routes/_authenticated/settings/_layout/inventory/index'
import { Route as AuthenticatedSettingsLayoutInvoicesIndexRouteImport } from './routes/_authenticated/settings/_layout/invoices/index'
import { Route as AuthenticatedSettingsLayoutInvoicesCreditNotesRouteImport } from './routes/_authenticated/settings/_layout/invoices/credit-notes'
import { Route as AuthenticatedSettingsLayoutInvoicesDebitNotesRouteImport } from './routes/_authenticated/settings/_layout/invoices/debit-notes'
import { Route as AuthenticatedSettingsLayoutInvoicesExemptsRouteImport } from './routes/_authenticated/settings/_layout/invoices/exempts'
import { Route as AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRouteImport } from './routes/_authenticated/settings/_layout/pdf-templates/$templateId'
import { Route as AuthenticatedSettingsLayoutScriptsIndexRouteImport } from './routes/_authenticated/settings/_layout/scripts/index'
import { Route as AuthenticatedSettingsLayoutScriptsScriptIdRouteImport } from './routes/_authenticated/settings/_layout/scripts/$scriptId'
import { Route as AuthenticatedSettingsLayoutSitesIndexRouteImport } from './routes/_authenticated/settings/_layout/sites/index'
import { Route as AuthenticatedSettingsLayoutSitesSiteKeyRouteImport } from './routes/_authenticated/settings/_layout/sites/$siteKey'
import { Route as SuperSuperControlPanelCompanyIdHistoryRouteImport } from './routes/_super/super/control-panel.$companyId.history'
import { Route as SuperSuperControlPanelCompanyIdOverviewRouteImport } from './routes/_super/super/control-panel.$companyId.overview'
import { Route as SuperSuperControlPanelCompanyIdSubscriptionRouteImport } from './routes/_super/super/control-panel.$companyId.subscription'
import { Route as SuperSuperControlPanelCompanyIdUsageRouteImport } from './routes/_super/super/control-panel.$companyId.usage'
import { Route as SuperSuperControlPanelCompanyIdUsersRouteImport } from './routes/_super/super/control-panel.$companyId.users'
import { Route as AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRouteImport } from './routes/_authenticated/settings/_layout/collections/config.$collectionId'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/_home',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperRoute = SuperRouteImport.update({
  id: '/_super',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedClientsRoute = AuthenticatedClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCollectionsRoute =
  AuthenticatedCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompleteProfileRoute =
  AuthenticatedCompleteProfileRouteImport.update({
    id: '/complete-profile',
    path: '/complete-profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentsRoute = AuthenticatedDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesRoute = AuthenticatedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOperationsRoute = AuthenticatedOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuotationsRoute = AuthenticatedQuotationsRouteImport.update({
  id: '/quotations',
  path: '/quotations',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReleaseNotesRoute =
  AuthenticatedReleaseNotesRouteImport.update({
    id: '/release-notes',
    path: '/release-notes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSalesRoute = AuthenticatedSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSubscriptionSuccessRoute =
  AuthenticatedSubscriptionSuccessRouteImport.update({
    id: '/subscription-success',
    path: '/subscription-success',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSubscriptionsRoute =
  AuthenticatedSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersRoute = AuthenticatedSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRoute,
} as any)
const HomeWaitlistRoute = HomeWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => HomeRoute,
} as any)
const PublicActivateRoute = PublicActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLicensesRoute = PublicLicensesRouteImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSetupRoute = PublicSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedDevCrdtPlaygroundRoute =
  AuthenticatedDevCrdtPlaygroundRouteImport.update({
    id: '/_dev/crdt-playground',
    path: '/crdt-playground',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiLayoutRoute = AuthenticatedAiLayoutRouteImport.update({
  id: '/ai/_layout',
  path: '/ai',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientsRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdRoute =
  AuthenticatedCollectionsCollectionIdRouteImport.update({
    id: '/$collectionId',
    path: '/$collectionId',
    getParentRoute: () => AuthenticatedCollectionsRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedInventoryCountsIndexRoute =
  AuthenticatedInventoryCountsIndexRouteImport.update({
    id: '/inventory-counts/',
    path: '/inventory-counts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryCountsNewRoute =
  AuthenticatedInventoryCountsNewRouteImport.update({
    id: '/inventory-counts/new',
    path: '/inventory-counts/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryIndexRoute =
  AuthenticatedInventoryIndexRouteImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryMovementsRoute =
  AuthenticatedInventoryMovementsRouteImport.update({
    id: '/inventory/movements',
    path: '/inventory/movements',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesNewRoute =
  AuthenticatedInvoicesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedOperationsPersonnelRolesRoute =
  AuthenticatedOperationsPersonnelRolesRouteImport.update({
    id: '/personnel-roles',
    path: '/personnel-roles',
    getParentRoute: () => AuthenticatedOperationsRoute,
  } as any)
const AuthenticatedProductsLayoutRoute =
  AuthenticatedProductsLayoutRouteImport.update({
    id: '/products/_layout',
    path: '/products',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchaseOrdersIndexRoute =
  AuthenticatedPurchaseOrdersIndexRouteImport.update({
    id: '/purchase-orders/',
    path: '/purchase-orders/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchaseOrdersNewRoute =
  AuthenticatedPurchaseOrdersNewRouteImport.update({
    id: '/purchase-orders/new',
    path: '/purchase-orders/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuotationsIndexRoute =
  AuthenticatedQuotationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedQuotationsRoute,
  } as any)
const AuthenticatedQuotationsNewRoute =
  AuthenticatedQuotationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedQuotationsRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedSalesIndexRoute = AuthenticatedSalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSalesRoute,
} as any)
const AuthenticatedSalesNewRoute = AuthenticatedSalesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedSalesRoute,
} as any)
const AuthenticatedServicesLayoutRoute =
  AuthenticatedServicesLayoutRouteImport.update({
    id: '/services/_layout',
    path: '/services',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsLayoutRoute =
  AuthenticatedSettingsLayoutRouteImport.update({
    id: '/settings/_layout',
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStockTransfersIndexRoute =
  AuthenticatedStockTransfersIndexRouteImport.update({
    id: '/stock-transfers/',
    path: '/stock-transfers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStockTransfersNewRoute =
  AuthenticatedStockTransfersNewRouteImport.update({
    id: '/stock-transfers/new',
    path: '/stock-transfers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersIndexRoute =
  AuthenticatedSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuppliersRoute,
  } as any)
const PublicAuthFirstTimeLoginRoute =
  PublicAuthFirstTimeLoginRouteImport.update({
    id: '/auth/first-time-login',
    path: '/auth/first-time-login',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicAuthResetPasswordRoute = PublicAuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthSignInRoute = PublicAuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthSignInWithOtpRoute = PublicAuthSignInWithOtpRouteImport.update({
  id: '/auth/sign-in-with-otp',
  path: '/auth/sign-in-with-otp',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthSignUpRoute = PublicAuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => PublicRoute,
} as any)
const SuperSuperLayoutRoute = SuperSuperLayoutRouteImport.update({
  id: '/super/_layout',
  path: '/super',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperCompaniesRoute = SuperSuperCompaniesRouteImport.update({
  id: '/super/companies',
  path: '/super/companies',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperDashboardRoute = SuperSuperDashboardRouteImport.update({
  id: '/super/dashboard',
  path: '/super/dashboard',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperLicensesRoute = SuperSuperLicensesRouteImport.update({
  id: '/super/licenses',
  path: '/super/licenses',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperPlansRoute = SuperSuperPlansRouteImport.update({
  id: '/super/plans',
  path: '/super/plans',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperReleasesRoute = SuperSuperReleasesRouteImport.update({
  id: '/super/releases',
  path: '/super/releases',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperSubscriptionsRoute = SuperSuperSubscriptionsRouteImport.update({
  id: '/super/subscriptions',
  path: '/super/subscriptions',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperUsersRoute = SuperSuperUsersRouteImport.update({
  id: '/super/users',
  path: '/super/users',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperWaitlistRoute = SuperSuperWaitlistRouteImport.update({
  id: '/super/waitlist',
  path: '/super/waitlist',
  getParentRoute: () => SuperRoute,
} as any)
const AuthenticatedAiLayoutIndexRoute =
  AuthenticatedAiLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAiLayoutRoute,
  } as any)
const AuthenticatedAiLayoutInsightsRoute =
  AuthenticatedAiLayoutInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedAiLayoutRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdIndexRoute =
  AuthenticatedCollectionsCollectionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdCalendarRoute =
  AuthenticatedCollectionsCollectionIdCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdKanbanRoute =
  AuthenticatedCollectionsCollectionIdKanbanRouteImport.update({
    id: '/kanban',
    path: '/kanban',
    getParentRoute: () => AuthenticatedCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdTableRoute =
  AuthenticatedCollectionsCollectionIdTableRouteImport.update({
    id: '/table',
    path: '/table',
    getParentRoute: () => AuthenticatedCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedDocumentsTemplatesNewRoute =
  AuthenticatedDocumentsTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedInventoryCountsIdEditRoute =
  AuthenticatedInventoryCountsIdEditRouteImport.update({
    id: '/inventory-counts/$id/edit',
    path: '/inventory-counts/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesIdEditRoute =
  AuthenticatedInvoicesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesCancelationsIndexRoute =
  AuthenticatedInvoicesCancelationsIndexRouteImport.update({
    id: '/cancelations/',
    path: '/cancelations/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesCreditNotesIndexRoute =
  AuthenticatedInvoicesCreditNotesIndexRouteImport.update({
    id: '/credit-notes/',
    path: '/credit-notes/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesCreditNotesNewRoute =
  AuthenticatedInvoicesCreditNotesNewRouteImport.update({
    id: '/credit-notes/new',
    path: '/credit-notes/new',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesCreditsIndexRoute =
  AuthenticatedInvoicesCreditsIndexRouteImport.update({
    id: '/credits/',
    path: '/credits/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesDebitNotesIndexRoute =
  AuthenticatedInvoicesDebitNotesIndexRouteImport.update({
    id: '/debit-notes/',
    path: '/debit-notes/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesDebitNotesNewRoute =
  AuthenticatedInvoicesDebitNotesNewRouteImport.update({
    id: '/debit-notes/new',
    path: '/debit-notes/new',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesExemptionsIndexRoute =
  AuthenticatedInvoicesExemptionsIndexRouteImport.update({
    id: '/exemptions/',
    path: '/exemptions/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesPaymentsIndexRoute =
  AuthenticatedInvoicesPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedOperationsEquipmentIndexRoute =
  AuthenticatedOperationsEquipmentIndexRouteImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => AuthenticatedOperationsRoute,
  } as any)
const AuthenticatedOperationsPersonnelIndexRoute =
  AuthenticatedOperationsPersonnelIndexRouteImport.update({
    id: '/personnel/',
    path: '/personnel/',
    getParentRoute: () => AuthenticatedOperationsRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersIdRoute =
  AuthenticatedOperationsWorkOrdersIdRouteImport.update({
    id: '/work-orders/$id',
    path: '/work-orders/$id',
    getParentRoute: () => AuthenticatedOperationsRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersListRoute =
  AuthenticatedOperationsWorkOrdersListRouteImport.update({
    id: '/work-orders/_list',
    path: '/work-orders',
    getParentRoute: () => AuthenticatedOperationsRoute,
  } as any)
const AuthenticatedProductsLayoutIndexRoute =
  AuthenticatedProductsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProductsLayoutRoute,
  } as any)
const AuthenticatedProductsLayoutNewRoute =
  AuthenticatedProductsLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedProductsLayoutRoute,
  } as any)
const AuthenticatedPurchaseOrdersIdEditRoute =
  AuthenticatedPurchaseOrdersIdEditRouteImport.update({
    id: '/purchase-orders/$id/edit',
    path: '/purchase-orders/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuotationsCodeEditRoute =
  AuthenticatedQuotationsCodeEditRouteImport.update({
    id: '/$code/edit',
    path: '/$code/edit',
    getParentRoute: () => AuthenticatedQuotationsRoute,
  } as any)
const AuthenticatedReportsIdBuilderRoute =
  AuthenticatedReportsIdBuilderRouteImport.update({
    id: '/$id/builder',
    path: '/$id/builder',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedSalesIdEditRoute =
  AuthenticatedSalesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedSalesRoute,
  } as any)
const AuthenticatedSalesSellersIndexRoute =
  AuthenticatedSalesSellersIndexRouteImport.update({
    id: '/sellers/',
    path: '/sellers/',
    getParentRoute: () => AuthenticatedSalesRoute,
  } as any)
const AuthenticatedServicesLayoutIndexRoute =
  AuthenticatedServicesLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedServicesLayoutRoute,
  } as any)
const AuthenticatedServicesLayoutNewRoute =
  AuthenticatedServicesLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedServicesLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutIndexRoute =
  AuthenticatedSettingsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutAiRoute =
  AuthenticatedSettingsLayoutAiRouteImport.update({
    id: '/ai',
    path: '/ai',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutBranchesRoute =
  AuthenticatedSettingsLayoutBranchesRouteImport.update({
    id: '/branches',
    path: '/branches',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCatalogsRoute =
  AuthenticatedSettingsLayoutCatalogsRouteImport.update({
    id: '/catalogs',
    path: '/catalogs',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCompaniesRoute =
  AuthenticatedSettingsLayoutCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCorrelativesRoute =
  AuthenticatedSettingsLayoutCorrelativesRouteImport.update({
    id: '/correlatives',
    path: '/correlatives',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutMigrationsRoute =
  AuthenticatedSettingsLayoutMigrationsRouteImport.update({
    id: '/migrations',
    path: '/migrations',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutNomenclaturesRoute =
  AuthenticatedSettingsLayoutNomenclaturesRouteImport.update({
    id: '/nomenclatures',
    path: '/nomenclatures',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutNotificationsRoute =
  AuthenticatedSettingsLayoutNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutRolesRoute =
  AuthenticatedSettingsLayoutRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutSchemaRoute =
  AuthenticatedSettingsLayoutSchemaRouteImport.update({
    id: '/schema',
    path: '/schema',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutSecurityRoute =
  AuthenticatedSettingsLayoutSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutSubscriptionRoute =
  AuthenticatedSettingsLayoutSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutTrashRoute =
  AuthenticatedSettingsLayoutTrashRouteImport.update({
    id: '/trash',
    path: '/trash',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutUsersRoute =
  AuthenticatedSettingsLayoutUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutWarehousesRoute =
  AuthenticatedSettingsLayoutWarehousesRouteImport.update({
    id: '/warehouses',
    path: '/warehouses',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedStockTransfersIdEditRoute =
  AuthenticatedStockTransfersIdEditRouteImport.update({
    id: '/stock-transfers/$id/edit',
    path: '/stock-transfers/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicSSlugIndexRoute = PublicSSlugIndexRouteImport.update({
  id: '/s/$slug/',
  path: '/s/$slug/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSSlugPageRoute = PublicSSlugPageRouteImport.update({
  id: '/s/$slug/$page',
  path: '/s/$slug/$page',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSharedDashboardsTokenRoute =
  PublicSharedDashboardsTokenRouteImport.update({
    id: '/shared/dashboards/$token',
    path: '/shared/dashboards/$token',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicSharedInvoicesIdRoute = PublicSharedInvoicesIdRouteImport.update({
  id: '/shared/invoices/$id',
  path: '/shared/invoices/$id',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSharedQuotationsIdRoute =
  PublicSharedQuotationsIdRouteImport.update({
    id: '/shared/quotations/$id',
    path: '/shared/quotations/$id',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicSharedSalesIdRoute = PublicSharedSalesIdRouteImport.update({
  id: '/shared/sales/$id',
  path: '/shared/sales/$id',
  getParentRoute: () => PublicRoute,
} as any)
const SuperSuperAppsIndexRoute = SuperSuperAppsIndexRouteImport.update({
  id: '/super/apps/',
  path: '/super/apps/',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperAppsVersionIdRoute = SuperSuperAppsVersionIdRouteImport.update({
  id: '/super/apps/$versionId',
  path: '/super/apps/$versionId',
  getParentRoute: () => SuperRoute,
} as any)
const SuperSuperControlPanelCompanyIdRoute =
  SuperSuperControlPanelCompanyIdRouteImport.update({
    id: '/super/control-panel/$companyId',
    path: '/super/control-panel/$companyId',
    getParentRoute: () => SuperRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute =
  AuthenticatedCollectionsCollectionIdRecordsRecordIdRouteImport.update({
    id: '/records/$recordId',
    path: '/records/$recordId',
    getParentRoute: () => AuthenticatedCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdRecordsNewRoute =
  AuthenticatedCollectionsCollectionIdRecordsNewRouteImport.update({
    id: '/records/new',
    path: '/records/new',
    getParentRoute: () => AuthenticatedCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedDocumentsRecordsIdEditRoute =
  AuthenticatedDocumentsRecordsIdEditRouteImport.update({
    id: '/records/$id/edit',
    path: '/records/$id/edit',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedDocumentsTemplatesIdEditRoute =
  AuthenticatedDocumentsTemplatesIdEditRouteImport.update({
    id: '/templates/$id/edit',
    path: '/templates/$id/edit',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute =
  AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRouteImport.update({
    id: '/credit-notes/$creditNoteId/',
    path: '/credit-notes/$creditNoteId/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute =
  AuthenticatedInvoicesCreditNotesCreditNoteIdEditRouteImport.update({
    id: '/credit-notes/$creditNoteId/edit',
    path: '/credit-notes/$creditNoteId/edit',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute =
  AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRouteImport.update({
    id: '/debit-notes/$debitNoteId/',
    path: '/debit-notes/$debitNoteId/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute =
  AuthenticatedInvoicesDebitNotesDebitNoteIdEditRouteImport.update({
    id: '/debit-notes/$debitNoteId/edit',
    path: '/debit-notes/$debitNoteId/edit',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersListIndexRoute =
  AuthenticatedOperationsWorkOrdersListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOperationsWorkOrdersListRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersListCalendarRoute =
  AuthenticatedOperationsWorkOrdersListCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedOperationsWorkOrdersListRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersListMineRoute =
  AuthenticatedOperationsWorkOrdersListMineRouteImport.update({
    id: '/mine',
    path: '/mine',
    getParentRoute: () => AuthenticatedOperationsWorkOrdersListRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersListTableRoute =
  AuthenticatedOperationsWorkOrdersListTableRouteImport.update({
    id: '/table',
    path: '/table',
    getParentRoute: () => AuthenticatedOperationsWorkOrdersListRoute,
  } as any)
const AuthenticatedOperationsWorkOrdersListWeekRoute =
  AuthenticatedOperationsWorkOrdersListWeekRouteImport.update({
    id: '/week',
    path: '/week',
    getParentRoute: () => AuthenticatedOperationsWorkOrdersListRoute,
  } as any)
const AuthenticatedProductsLayoutIdEditRoute =
  AuthenticatedProductsLayoutIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedProductsLayoutRoute,
  } as any)
const AuthenticatedServicesLayoutIdEditRoute =
  AuthenticatedServicesLayoutIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedServicesLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutAgentsIndexRoute =
  AuthenticatedSettingsLayoutAgentsIndexRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutAppsIndexRoute =
  AuthenticatedSettingsLayoutAppsIndexRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutAppsListingIdRoute =
  AuthenticatedSettingsLayoutAppsListingIdRouteImport.update({
    id: '/apps/$listingId',
    path: '/apps/$listingId',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutAppsPublishRoute =
  AuthenticatedSettingsLayoutAppsPublishRouteImport.update({
    id: '/apps/publish',
    path: '/apps/publish',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCollectionsIndexRoute =
  AuthenticatedSettingsLayoutCollectionsIndexRouteImport.update({
    id: '/collections/',
    path: '/collections/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutCollectionsSchemaRoute =
  AuthenticatedSettingsLayoutCollectionsSchemaRouteImport.update({
    id: '/collections/schema',
    path: '/collections/schema',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute =
  AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRouteImport.update({
    id: '/email-templates/$templateId',
    path: '/email-templates/$templateId',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutIntegrationsIndexRoute =
  AuthenticatedSettingsLayoutIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute =
  AuthenticatedSettingsLayoutIntegrationsConnectionIdRouteImport.update({
    id: '/integrations/$connectionId',
    path: '/integrations/$connectionId',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutInventoryIndexRoute =
  AuthenticatedSettingsLayoutInventoryIndexRouteImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutInvoicesIndexRoute =
  AuthenticatedSettingsLayoutInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutInvoicesCreditNotesRoute =
  AuthenticatedSettingsLayoutInvoicesCreditNotesRouteImport.update({
    id: '/invoices/credit-notes',
    path: '/invoices/credit-notes',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutInvoicesDebitNotesRoute =
  AuthenticatedSettingsLayoutInvoicesDebitNotesRouteImport.update({
    id: '/invoices/debit-notes',
    path: '/invoices/debit-notes',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutInvoicesExemptsRoute =
  AuthenticatedSettingsLayoutInvoicesExemptsRouteImport.update({
    id: '/invoices/exempts',
    path: '/invoices/exempts',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute =
  AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRouteImport.update({
    id: '/pdf-templates/$templateId',
    path: '/pdf-templates/$templateId',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutScriptsIndexRoute =
  AuthenticatedSettingsLayoutScriptsIndexRouteImport.update({
    id: '/scripts/',
    path: '/scripts/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutScriptsScriptIdRoute =
  AuthenticatedSettingsLayoutScriptsScriptIdRouteImport.update({
    id: '/scripts/$scriptId',
    path: '/scripts/$scriptId',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutSitesIndexRoute =
  AuthenticatedSettingsLayoutSitesIndexRouteImport.update({
    id: '/sites/',
    path: '/sites/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const AuthenticatedSettingsLayoutSitesSiteKeyRoute =
  AuthenticatedSettingsLayoutSitesSiteKeyRouteImport.update({
    id: '/sites/$siteKey',
    path: '/sites/$siteKey',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)
const SuperSuperControlPanelCompanyIdHistoryRoute =
  SuperSuperControlPanelCompanyIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdOverviewRoute =
  SuperSuperControlPanelCompanyIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdSubscriptionRoute =
  SuperSuperControlPanelCompanyIdSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdUsageRoute =
  SuperSuperControlPanelCompanyIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const SuperSuperControlPanelCompanyIdUsersRoute =
  SuperSuperControlPanelCompanyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => SuperSuperControlPanelCompanyIdRoute,
  } as any)
const AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute =
  AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRouteImport.update({
    id: '/collections/config/$collectionId',
    path: '/collections/config/$collectionId',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof HomeIndexRoute
  '/clients': typeof AuthenticatedClientsRouteWithChildren
  '/collections': typeof AuthenticatedCollectionsRouteWithChildren
  '/complete-profile': typeof AuthenticatedCompleteProfileRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/invoices': typeof AuthenticatedInvoicesRouteWithChildren
  '/operations': typeof AuthenticatedOperationsRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/quotations': typeof AuthenticatedQuotationsRouteWithChildren
  '/release-notes': typeof AuthenticatedReleaseNotesRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/sales': typeof AuthenticatedSalesRouteWithChildren
  '/subscription-success': typeof AuthenticatedSubscriptionSuccessRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/suppliers': typeof AuthenticatedSuppliersRouteWithChildren
  '/waitlist': typeof HomeWaitlistRoute
  '/activate': typeof PublicActivateRoute
  '/licenses': typeof PublicLicensesRoute
  '/setup': typeof PublicSetupRoute
  '/crdt-playground': typeof AuthenticatedDevCrdtPlaygroundRoute
  '/ai': typeof AuthenticatedAiLayoutRouteWithChildren
  '/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRouteWithChildren
  '/inventory-counts/new': typeof AuthenticatedInventoryCountsNewRoute
  '/inventory/movements': typeof AuthenticatedInventoryMovementsRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/operations/personnel-roles': typeof AuthenticatedOperationsPersonnelRolesRoute
  '/products': typeof AuthenticatedProductsLayoutRouteWithChildren
  '/purchase-orders/new': typeof AuthenticatedPurchaseOrdersNewRoute
  '/quotations/new': typeof AuthenticatedQuotationsNewRoute
  '/sales/new': typeof AuthenticatedSalesNewRoute
  '/services': typeof AuthenticatedServicesLayoutRouteWithChildren
  '/settings': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/stock-transfers/new': typeof AuthenticatedStockTransfersNewRoute
  '/auth/first-time-login': typeof PublicAuthFirstTimeLoginRoute
  '/auth/reset-password': typeof PublicAuthResetPasswordRoute
  '/auth/sign-in': typeof PublicAuthSignInRoute
  '/auth/sign-in-with-otp': typeof PublicAuthSignInWithOtpRoute
  '/auth/sign-up': typeof PublicAuthSignUpRoute
  '/super': typeof SuperSuperLayoutRoute
  '/super/companies': typeof SuperSuperCompaniesRoute
  '/super/dashboard': typeof SuperSuperDashboardRoute
  '/super/licenses': typeof SuperSuperLicensesRoute
  '/super/plans': typeof SuperSuperPlansRoute
  '/super/releases': typeof SuperSuperReleasesRoute
  '/super/subscriptions': typeof SuperSuperSubscriptionsRoute
  '/super/users': typeof SuperSuperUsersRoute
  '/super/waitlist': typeof SuperSuperWaitlistRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/inventory-counts/': typeof AuthenticatedInventoryCountsIndexRoute
  '/inventory/': typeof AuthenticatedInventoryIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/purchase-orders/': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/quotations/': typeof AuthenticatedQuotationsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/sales/': typeof AuthenticatedSalesIndexRoute
  '/stock-transfers/': typeof AuthenticatedStockTransfersIndexRoute
  '/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/ai/insights': typeof AuthenticatedAiLayoutInsightsRoute
  '/collections/$collectionId/calendar': typeof AuthenticatedCollectionsCollectionIdCalendarRoute
  '/collections/$collectionId/kanban': typeof AuthenticatedCollectionsCollectionIdKanbanRoute
  '/collections/$collectionId/table': typeof AuthenticatedCollectionsCollectionIdTableRoute
  '/documents/templates/new': typeof AuthenticatedDocumentsTemplatesNewRoute
  '/inventory-counts/$id/edit': typeof AuthenticatedInventoryCountsIdEditRoute
  '/invoices/$id/edit': typeof AuthenticatedInvoicesIdEditRoute
  '/invoices/credit-notes/new': typeof AuthenticatedInvoicesCreditNotesNewRoute
  '/invoices/debit-notes/new': typeof AuthenticatedInvoicesDebitNotesNewRoute
  '/operations/work-orders/$id': typeof AuthenticatedOperationsWorkOrdersIdRoute
  '/operations/work-orders': typeof AuthenticatedOperationsWorkOrdersListRouteWithChildren
  '/products/new': typeof AuthenticatedProductsLayoutNewRoute
  '/purchase-orders/$id/edit': typeof AuthenticatedPurchaseOrdersIdEditRoute
  '/quotations/$code/edit': typeof AuthenticatedQuotationsCodeEditRoute
  '/reports/$id/builder': typeof AuthenticatedReportsIdBuilderRoute
  '/sales/$id/edit': typeof AuthenticatedSalesIdEditRoute
  '/services/new': typeof AuthenticatedServicesLayoutNewRoute
  '/settings/ai': typeof AuthenticatedSettingsLayoutAiRoute
  '/settings/branches': typeof AuthenticatedSettingsLayoutBranchesRoute
  '/settings/catalogs': typeof AuthenticatedSettingsLayoutCatalogsRoute
  '/settings/companies': typeof AuthenticatedSettingsLayoutCompaniesRoute
  '/settings/correlatives': typeof AuthenticatedSettingsLayoutCorrelativesRoute
  '/settings/migrations': typeof AuthenticatedSettingsLayoutMigrationsRoute
  '/settings/nomenclatures': typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  '/settings/notifications': typeof AuthenticatedSettingsLayoutNotificationsRoute
  '/settings/roles': typeof AuthenticatedSettingsLayoutRolesRoute
  '/settings/schema': typeof AuthenticatedSettingsLayoutSchemaRoute
  '/settings/security': typeof AuthenticatedSettingsLayoutSecurityRoute
  '/settings/subscription': typeof AuthenticatedSettingsLayoutSubscriptionRoute
  '/settings/trash': typeof AuthenticatedSettingsLayoutTrashRoute
  '/settings/users': typeof AuthenticatedSettingsLayoutUsersRoute
  '/settings/warehouses': typeof AuthenticatedSettingsLayoutWarehousesRoute
  '/stock-transfers/$id/edit': typeof AuthenticatedStockTransfersIdEditRoute
  '/s/$slug/$page': typeof PublicSSlugPageRoute
  '/shared/dashboards/$token': typeof PublicSharedDashboardsTokenRoute
  '/shared/invoices/$id': typeof PublicSharedInvoicesIdRoute
  '/shared/quotations/$id': typeof PublicSharedQuotationsIdRoute
  '/shared/sales/$id': typeof PublicSharedSalesIdRoute
  '/super/apps/$versionId': typeof SuperSuperAppsVersionIdRoute
  '/super/control-panel/$companyId': typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  '/ai/': typeof AuthenticatedAiLayoutIndexRoute
  '/collections/$collectionId/': typeof AuthenticatedCollectionsCollectionIdIndexRoute
  '/invoices/cancelations/': typeof AuthenticatedInvoicesCancelationsIndexRoute
  '/invoices/credit-notes/': typeof AuthenticatedInvoicesCreditNotesIndexRoute
  '/invoices/credits/': typeof AuthenticatedInvoicesCreditsIndexRoute
  '/invoices/debit-notes/': typeof AuthenticatedInvoicesDebitNotesIndexRoute
  '/invoices/exemptions/': typeof AuthenticatedInvoicesExemptionsIndexRoute
  '/invoices/payments/': typeof AuthenticatedInvoicesPaymentsIndexRoute
  '/operations/equipment/': typeof AuthenticatedOperationsEquipmentIndexRoute
  '/operations/personnel/': typeof AuthenticatedOperationsPersonnelIndexRoute
  '/products/': typeof AuthenticatedProductsLayoutIndexRoute
  '/sales/sellers/': typeof AuthenticatedSalesSellersIndexRoute
  '/services/': typeof AuthenticatedServicesLayoutIndexRoute
  '/settings/': typeof AuthenticatedSettingsLayoutIndexRoute
  '/s/$slug/': typeof PublicSSlugIndexRoute
  '/super/apps/': typeof SuperSuperAppsIndexRoute
  '/collections/$collectionId/records/$recordId': typeof AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute
  '/collections/$collectionId/records/new': typeof AuthenticatedCollectionsCollectionIdRecordsNewRoute
  '/documents/records/$id/edit': typeof AuthenticatedDocumentsRecordsIdEditRoute
  '/documents/templates/$id/edit': typeof AuthenticatedDocumentsTemplatesIdEditRoute
  '/invoices/credit-notes/$creditNoteId/edit': typeof AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute
  '/invoices/debit-notes/$debitNoteId/edit': typeof AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute
  '/operations/work-orders/calendar': typeof AuthenticatedOperationsWorkOrdersListCalendarRoute
  '/operations/work-orders/mine': typeof AuthenticatedOperationsWorkOrdersListMineRoute
  '/operations/work-orders/table': typeof AuthenticatedOperationsWorkOrdersListTableRoute
  '/operations/work-orders/week': typeof AuthenticatedOperationsWorkOrdersListWeekRoute
  '/products/$id/edit': typeof AuthenticatedProductsLayoutIdEditRoute
  '/services/$id/edit': typeof AuthenticatedServicesLayoutIdEditRoute
  '/settings/apps/$listingId': typeof AuthenticatedSettingsLayoutAppsListingIdRoute
  '/settings/apps/publish': typeof AuthenticatedSettingsLayoutAppsPublishRoute
  '/settings/collections/schema': typeof AuthenticatedSettingsLayoutCollectionsSchemaRoute
  '/settings/email-templates/$templateId': typeof AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute
  '/settings/integrations/$connectionId': typeof AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute
  '/settings/invoices/credit-notes': typeof AuthenticatedSettingsLayoutInvoicesCreditNotesRoute
  '/settings/invoices/debit-notes': typeof AuthenticatedSettingsLayoutInvoicesDebitNotesRoute
  '/settings/invoices/exempts': typeof AuthenticatedSettingsLayoutInvoicesExemptsRoute
  '/settings/pdf-templates/$templateId': typeof AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute
  '/settings/scripts/$scriptId': typeof AuthenticatedSettingsLayoutScriptsScriptIdRoute
  '/settings/sites/$siteKey': typeof AuthenticatedSettingsLayoutSitesSiteKeyRoute
  '/super/control-panel/$companyId/history': typeof SuperSuperControlPanelCompanyIdHistoryRoute
  '/super/control-panel/$companyId/overview': typeof SuperSuperControlPanelCompanyIdOverviewRoute
  '/super/control-panel/$companyId/subscription': typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  '/super/control-panel/$companyId/usage': typeof SuperSuperControlPanelCompanyIdUsageRoute
  '/super/control-panel/$companyId/users': typeof SuperSuperControlPanelCompanyIdUsersRoute
  '/invoices/credit-notes/$creditNoteId/': typeof AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute
  '/invoices/debit-notes/$debitNoteId/': typeof AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute
  '/operations/work-orders/': typeof AuthenticatedOperationsWorkOrdersListIndexRoute
  '/settings/agents/': typeof AuthenticatedSettingsLayoutAgentsIndexRoute
  '/settings/apps/': typeof AuthenticatedSettingsLayoutAppsIndexRoute
  '/settings/collections/': typeof AuthenticatedSettingsLayoutCollectionsIndexRoute
  '/settings/integrations/': typeof AuthenticatedSettingsLayoutIntegrationsIndexRoute
  '/settings/inventory/': typeof AuthenticatedSettingsLayoutInventoryIndexRoute
  '/settings/invoices/': typeof AuthenticatedSettingsLayoutInvoicesIndexRoute
  '/settings/scripts/': typeof AuthenticatedSettingsLayoutScriptsIndexRoute
  '/settings/sites/': typeof AuthenticatedSettingsLayoutSitesIndexRoute
  '/settings/collections/config/$collectionId': typeof AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/': typeof HomeIndexRoute
  '/collections': typeof AuthenticatedCollectionsRouteWithChildren
  '/complete-profile': typeof AuthenticatedCompleteProfileRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/operations': typeof AuthenticatedOperationsRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/release-notes': typeof AuthenticatedReleaseNotesRoute
  '/subscription-success': typeof AuthenticatedSubscriptionSuccessRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/waitlist': typeof HomeWaitlistRoute
  '/activate': typeof PublicActivateRoute
  '/licenses': typeof PublicLicensesRoute
  '/setup': typeof PublicSetupRoute
  '/crdt-playground': typeof AuthenticatedDevCrdtPlaygroundRoute
  '/inventory-counts/new': typeof AuthenticatedInventoryCountsNewRoute
  '/inventory/movements': typeof AuthenticatedInventoryMovementsRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/operations/personnel-roles': typeof AuthenticatedOperationsPersonnelRolesRoute
  '/purchase-orders/new': typeof AuthenticatedPurchaseOrdersNewRoute
  '/quotations/new': typeof AuthenticatedQuotationsNewRoute
  '/sales/new': typeof AuthenticatedSalesNewRoute
  '/stock-transfers/new': typeof AuthenticatedStockTransfersNewRoute
  '/auth/first-time-login': typeof PublicAuthFirstTimeLoginRoute
  '/auth/reset-password': typeof PublicAuthResetPasswordRoute
  '/auth/sign-in': typeof PublicAuthSignInRoute
  '/auth/sign-in-with-otp': typeof PublicAuthSignInWithOtpRoute
  '/auth/sign-up': typeof PublicAuthSignUpRoute
  '/super': typeof SuperSuperLayoutRoute
  '/super/companies': typeof SuperSuperCompaniesRoute
  '/super/dashboard': typeof SuperSuperDashboardRoute
  '/super/licenses': typeof SuperSuperLicensesRoute
  '/super/plans': typeof SuperSuperPlansRoute
  '/super/releases': typeof SuperSuperReleasesRoute
  '/super/subscriptions': typeof SuperSuperSubscriptionsRoute
  '/super/users': typeof SuperSuperUsersRoute
  '/super/waitlist': typeof SuperSuperWaitlistRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/inventory-counts': typeof AuthenticatedInventoryCountsIndexRoute
  '/inventory': typeof AuthenticatedInventoryIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/quotations': typeof AuthenticatedQuotationsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/sales': typeof AuthenticatedSalesIndexRoute
  '/stock-transfers': typeof AuthenticatedStockTransfersIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersIndexRoute
  '/ai/insights': typeof AuthenticatedAiLayoutInsightsRoute
  '/collections/$collectionId/calendar': typeof AuthenticatedCollectionsCollectionIdCalendarRoute
  '/collections/$collectionId/kanban': typeof AuthenticatedCollectionsCollectionIdKanbanRoute
  '/collections/$collectionId/table': typeof AuthenticatedCollectionsCollectionIdTableRoute
  '/documents/templates/new': typeof AuthenticatedDocumentsTemplatesNewRoute
  '/inventory-counts/$id/edit': typeof AuthenticatedInventoryCountsIdEditRoute
  '/invoices/$id/edit': typeof AuthenticatedInvoicesIdEditRoute
  '/invoices/credit-notes/new': typeof AuthenticatedInvoicesCreditNotesNewRoute
  '/invoices/debit-notes/new': typeof AuthenticatedInvoicesDebitNotesNewRoute
  '/operations/work-orders/$id': typeof AuthenticatedOperationsWorkOrdersIdRoute
  '/products/new': typeof AuthenticatedProductsLayoutNewRoute
  '/purchase-orders/$id/edit': typeof AuthenticatedPurchaseOrdersIdEditRoute
  '/quotations/$code/edit': typeof AuthenticatedQuotationsCodeEditRoute
  '/reports/$id/builder': typeof AuthenticatedReportsIdBuilderRoute
  '/sales/$id/edit': typeof AuthenticatedSalesIdEditRoute
  '/services/new': typeof AuthenticatedServicesLayoutNewRoute
  '/settings/ai': typeof AuthenticatedSettingsLayoutAiRoute
  '/settings/branches': typeof AuthenticatedSettingsLayoutBranchesRoute
  '/settings/catalogs': typeof AuthenticatedSettingsLayoutCatalogsRoute
  '/settings/companies': typeof AuthenticatedSettingsLayoutCompaniesRoute
  '/settings/correlatives': typeof AuthenticatedSettingsLayoutCorrelativesRoute
  '/settings/migrations': typeof AuthenticatedSettingsLayoutMigrationsRoute
  '/settings/nomenclatures': typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  '/settings/notifications': typeof AuthenticatedSettingsLayoutNotificationsRoute
  '/settings/roles': typeof AuthenticatedSettingsLayoutRolesRoute
  '/settings/schema': typeof AuthenticatedSettingsLayoutSchemaRoute
  '/settings/security': typeof AuthenticatedSettingsLayoutSecurityRoute
  '/settings/subscription': typeof AuthenticatedSettingsLayoutSubscriptionRoute
  '/settings/trash': typeof AuthenticatedSettingsLayoutTrashRoute
  '/settings/users': typeof AuthenticatedSettingsLayoutUsersRoute
  '/settings/warehouses': typeof AuthenticatedSettingsLayoutWarehousesRoute
  '/stock-transfers/$id/edit': typeof AuthenticatedStockTransfersIdEditRoute
  '/s/$slug/$page': typeof PublicSSlugPageRoute
  '/shared/dashboards/$token': typeof PublicSharedDashboardsTokenRoute
  '/shared/invoices/$id': typeof PublicSharedInvoicesIdRoute
  '/shared/quotations/$id': typeof PublicSharedQuotationsIdRoute
  '/shared/sales/$id': typeof PublicSharedSalesIdRoute
  '/super/apps/$versionId': typeof SuperSuperAppsVersionIdRoute
  '/super/control-panel/$companyId': typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  '/ai': typeof AuthenticatedAiLayoutIndexRoute
  '/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdIndexRoute
  '/invoices/cancelations': typeof AuthenticatedInvoicesCancelationsIndexRoute
  '/invoices/credit-notes': typeof AuthenticatedInvoicesCreditNotesIndexRoute
  '/invoices/credits': typeof AuthenticatedInvoicesCreditsIndexRoute
  '/invoices/debit-notes': typeof AuthenticatedInvoicesDebitNotesIndexRoute
  '/invoices/exemptions': typeof AuthenticatedInvoicesExemptionsIndexRoute
  '/invoices/payments': typeof AuthenticatedInvoicesPaymentsIndexRoute
  '/operations/equipment': typeof AuthenticatedOperationsEquipmentIndexRoute
  '/operations/personnel': typeof AuthenticatedOperationsPersonnelIndexRoute
  '/products': typeof AuthenticatedProductsLayoutIndexRoute
  '/sales/sellers': typeof AuthenticatedSalesSellersIndexRoute
  '/services': typeof AuthenticatedServicesLayoutIndexRoute
  '/settings': typeof AuthenticatedSettingsLayoutIndexRoute
  '/s/$slug': typeof PublicSSlugIndexRoute
  '/super/apps': typeof SuperSuperAppsIndexRoute
  '/collections/$collectionId/records/$recordId': typeof AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute
  '/collections/$collectionId/records/new': typeof AuthenticatedCollectionsCollectionIdRecordsNewRoute
  '/documents/records/$id/edit': typeof AuthenticatedDocumentsRecordsIdEditRoute
  '/documents/templates/$id/edit': typeof AuthenticatedDocumentsTemplatesIdEditRoute
  '/invoices/credit-notes/$creditNoteId/edit': typeof AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute
  '/invoices/debit-notes/$debitNoteId/edit': typeof AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute
  '/operations/work-orders/calendar': typeof AuthenticatedOperationsWorkOrdersListCalendarRoute
  '/operations/work-orders/mine': typeof AuthenticatedOperationsWorkOrdersListMineRoute
  '/operations/work-orders/table': typeof AuthenticatedOperationsWorkOrdersListTableRoute
  '/operations/work-orders/week': typeof AuthenticatedOperationsWorkOrdersListWeekRoute
  '/products/$id/edit': typeof AuthenticatedProductsLayoutIdEditRoute
  '/services/$id/edit': typeof AuthenticatedServicesLayoutIdEditRoute
  '/settings/apps/$listingId': typeof AuthenticatedSettingsLayoutAppsListingIdRoute
  '/settings/apps/publish': typeof AuthenticatedSettingsLayoutAppsPublishRoute
  '/settings/collections/schema': typeof AuthenticatedSettingsLayoutCollectionsSchemaRoute
  '/settings/email-templates/$templateId': typeof AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute
  '/settings/integrations/$connectionId': typeof AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute
  '/settings/invoices/credit-notes': typeof AuthenticatedSettingsLayoutInvoicesCreditNotesRoute
  '/settings/invoices/debit-notes': typeof AuthenticatedSettingsLayoutInvoicesDebitNotesRoute
  '/settings/invoices/exempts': typeof AuthenticatedSettingsLayoutInvoicesExemptsRoute
  '/settings/pdf-templates/$templateId': typeof AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute
  '/settings/scripts/$scriptId': typeof AuthenticatedSettingsLayoutScriptsScriptIdRoute
  '/settings/sites/$siteKey': typeof AuthenticatedSettingsLayoutSitesSiteKeyRoute
  '/super/control-panel/$companyId/history': typeof SuperSuperControlPanelCompanyIdHistoryRoute
  '/super/control-panel/$companyId/overview': typeof SuperSuperControlPanelCompanyIdOverviewRoute
  '/super/control-panel/$companyId/subscription': typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  '/super/control-panel/$companyId/usage': typeof SuperSuperControlPanelCompanyIdUsageRoute
  '/super/control-panel/$companyId/users': typeof SuperSuperControlPanelCompanyIdUsersRoute
  '/invoices/credit-notes/$creditNoteId': typeof AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute
  '/invoices/debit-notes/$debitNoteId': typeof AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute
  '/operations/work-orders': typeof AuthenticatedOperationsWorkOrdersListIndexRoute
  '/settings/agents': typeof AuthenticatedSettingsLayoutAgentsIndexRoute
  '/settings/apps': typeof AuthenticatedSettingsLayoutAppsIndexRoute
  '/settings/collections': typeof AuthenticatedSettingsLayoutCollectionsIndexRoute
  '/settings/integrations': typeof AuthenticatedSettingsLayoutIntegrationsIndexRoute
  '/settings/inventory': typeof AuthenticatedSettingsLayoutInventoryIndexRoute
  '/settings/invoices': typeof AuthenticatedSettingsLayoutInvoicesIndexRoute
  '/settings/scripts': typeof AuthenticatedSettingsLayoutScriptsIndexRoute
  '/settings/sites': typeof AuthenticatedSettingsLayoutSitesIndexRoute
  '/settings/collections/config/$collectionId': typeof AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_home': typeof HomeRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_super': typeof SuperRouteWithChildren
  '/_authenticated/clients': typeof AuthenticatedClientsRouteWithChildren
  '/_authenticated/collections': typeof AuthenticatedCollectionsRouteWithChildren
  '/_authenticated/complete-profile': typeof AuthenticatedCompleteProfileRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/_authenticated/invoices': typeof AuthenticatedInvoicesRouteWithChildren
  '/_authenticated/operations': typeof AuthenticatedOperationsRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/quotations': typeof AuthenticatedQuotationsRouteWithChildren
  '/_authenticated/release-notes': typeof AuthenticatedReleaseNotesRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/sales': typeof AuthenticatedSalesRouteWithChildren
  '/_authenticated/subscription-success': typeof AuthenticatedSubscriptionSuccessRoute
  '/_authenticated/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/_authenticated/suppliers': typeof AuthenticatedSuppliersRouteWithChildren
  '/_home/waitlist': typeof HomeWaitlistRoute
  '/_public/activate': typeof PublicActivateRoute
  '/_public/licenses': typeof PublicLicensesRoute
  '/_public/setup': typeof PublicSetupRoute
  '/_home/': typeof HomeIndexRoute
  '/_authenticated/_dev/crdt-playground': typeof AuthenticatedDevCrdtPlaygroundRoute
  '/_authenticated/ai/_layout': typeof AuthenticatedAiLayoutRouteWithChildren
  '/_authenticated/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRouteWithChildren
  '/_authenticated/inventory-counts/new': typeof AuthenticatedInventoryCountsNewRoute
  '/_authenticated/inventory/movements': typeof AuthenticatedInventoryMovementsRoute
  '/_authenticated/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/_authenticated/operations/personnel-roles': typeof AuthenticatedOperationsPersonnelRolesRoute
  '/_authenticated/products/_layout': typeof AuthenticatedProductsLayoutRouteWithChildren
  '/_authenticated/purchase-orders/new': typeof AuthenticatedPurchaseOrdersNewRoute
  '/_authenticated/quotations/new': typeof AuthenticatedQuotationsNewRoute
  '/_authenticated/sales/new': typeof AuthenticatedSalesNewRoute
  '/_authenticated/services/_layout': typeof AuthenticatedServicesLayoutRouteWithChildren
  '/_authenticated/settings/_layout': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/_authenticated/stock-transfers/new': typeof AuthenticatedStockTransfersNewRoute
  '/_public/auth/first-time-login': typeof PublicAuthFirstTimeLoginRoute
  '/_public/auth/reset-password': typeof PublicAuthResetPasswordRoute
  '/_public/auth/sign-in': typeof PublicAuthSignInRoute
  '/_public/auth/sign-in-with-otp': typeof PublicAuthSignInWithOtpRoute
  '/_public/auth/sign-up': typeof PublicAuthSignUpRoute
  '/_super/super/_layout': typeof SuperSuperLayoutRoute
  '/_super/super/companies': typeof SuperSuperCompaniesRoute
  '/_super/super/dashboard': typeof SuperSuperDashboardRoute
  '/_super/super/licenses': typeof SuperSuperLicensesRoute
  '/_super/super/plans': typeof SuperSuperPlansRoute
  '/_super/super/releases': typeof SuperSuperReleasesRoute
  '/_super/super/subscriptions': typeof SuperSuperSubscriptionsRoute
  '/_super/super/users': typeof SuperSuperUsersRoute
  '/_super/super/waitlist': typeof SuperSuperWaitlistRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/inventory-counts/': typeof AuthenticatedInventoryCountsIndexRoute
  '/_authenticated/inventory/': typeof AuthenticatedInventoryIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/purchase-orders/': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/_authenticated/quotations/': typeof AuthenticatedQuotationsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/sales/': typeof AuthenticatedSalesIndexRoute
  '/_authenticated/stock-transfers/': typeof AuthenticatedStockTransfersIndexRoute
  '/_authenticated/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/_authenticated/ai/_layout/insights': typeof AuthenticatedAiLayoutInsightsRoute
  '/_authenticated/collections/$collectionId/calendar': typeof AuthenticatedCollectionsCollectionIdCalendarRoute
  '/_authenticated/collections/$collectionId/kanban': typeof AuthenticatedCollectionsCollectionIdKanbanRoute
  '/_authenticated/collections/$collectionId/table': typeof AuthenticatedCollectionsCollectionIdTableRoute
  '/_authenticated/documents/templates/new': typeof AuthenticatedDocumentsTemplatesNewRoute
  '/_authenticated/inventory-counts/$id/edit': typeof AuthenticatedInventoryCountsIdEditRoute
  '/_authenticated/invoices/$id/edit': typeof AuthenticatedInvoicesIdEditRoute
  '/_authenticated/invoices/credit-notes/new': typeof AuthenticatedInvoicesCreditNotesNewRoute
  '/_authenticated/invoices/debit-notes/new': typeof AuthenticatedInvoicesDebitNotesNewRoute
  '/_authenticated/operations/work-orders/$id': typeof AuthenticatedOperationsWorkOrdersIdRoute
  '/_authenticated/operations/work-orders/_list': typeof AuthenticatedOperationsWorkOrdersListRouteWithChildren
  '/_authenticated/products/_layout/new': typeof AuthenticatedProductsLayoutNewRoute
  '/_authenticated/purchase-orders/$id/edit': typeof AuthenticatedPurchaseOrdersIdEditRoute
  '/_authenticated/quotations/$code/edit': typeof AuthenticatedQuotationsCodeEditRoute
  '/_authenticated/reports/$id/builder': typeof AuthenticatedReportsIdBuilderRoute
  '/_authenticated/sales/$id/edit': typeof AuthenticatedSalesIdEditRoute
  '/_authenticated/services/_layout/new': typeof AuthenticatedServicesLayoutNewRoute
  '/_authenticated/settings/_layout/ai': typeof AuthenticatedSettingsLayoutAiRoute
  '/_authenticated/settings/_layout/branches': typeof AuthenticatedSettingsLayoutBranchesRoute
  '/_authenticated/settings/_layout/catalogs': typeof AuthenticatedSettingsLayoutCatalogsRoute
  '/_authenticated/settings/_layout/companies': typeof AuthenticatedSettingsLayoutCompaniesRoute
  '/_authenticated/settings/_layout/correlatives': typeof AuthenticatedSettingsLayoutCorrelativesRoute
  '/_authenticated/settings/_layout/migrations': typeof AuthenticatedSettingsLayoutMigrationsRoute
  '/_authenticated/settings/_layout/nomenclatures': typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  '/_authenticated/settings/_layout/notifications': typeof AuthenticatedSettingsLayoutNotificationsRoute
  '/_authenticated/settings/_layout/roles': typeof AuthenticatedSettingsLayoutRolesRoute
  '/_authenticated/settings/_layout/schema': typeof AuthenticatedSettingsLayoutSchemaRoute
  '/_authenticated/settings/_layout/security': typeof AuthenticatedSettingsLayoutSecurityRoute
  '/_authenticated/settings/_layout/subscription': typeof AuthenticatedSettingsLayoutSubscriptionRoute
  '/_authenticated/settings/_layout/trash': typeof AuthenticatedSettingsLayoutTrashRoute
  '/_authenticated/settings/_layout/users': typeof AuthenticatedSettingsLayoutUsersRoute
  '/_authenticated/settings/_layout/warehouses': typeof AuthenticatedSettingsLayoutWarehousesRoute
  '/_authenticated/stock-transfers/$id/edit': typeof AuthenticatedStockTransfersIdEditRoute
  '/_public/s/$slug/$page': typeof PublicSSlugPageRoute
  '/_public/shared/dashboards/$token': typeof PublicSharedDashboardsTokenRoute
  '/_public/shared/invoices/$id': typeof PublicSharedInvoicesIdRoute
  '/_public/shared/quotations/$id': typeof PublicSharedQuotationsIdRoute
  '/_public/shared/sales/$id': typeof PublicSharedSalesIdRoute
  '/_super/super/apps/$versionId': typeof SuperSuperAppsVersionIdRoute
  '/_super/super/control-panel/$companyId': typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  '/_authenticated/ai/_layout/': typeof AuthenticatedAiLayoutIndexRoute
  '/_authenticated/collections/$collectionId/': typeof AuthenticatedCollectionsCollectionIdIndexRoute
  '/_authenticated/invoices/cancelations/': typeof AuthenticatedInvoicesCancelationsIndexRoute
  '/_authenticated/invoices/credit-notes/': typeof AuthenticatedInvoicesCreditNotesIndexRoute
  '/_authenticated/invoices/credits/': typeof AuthenticatedInvoicesCreditsIndexRoute
  '/_authenticated/invoices/debit-notes/': typeof AuthenticatedInvoicesDebitNotesIndexRoute
  '/_authenticated/invoices/exemptions/': typeof AuthenticatedInvoicesExemptionsIndexRoute
  '/_authenticated/invoices/payments/': typeof AuthenticatedInvoicesPaymentsIndexRoute
  '/_authenticated/operations/equipment/': typeof AuthenticatedOperationsEquipmentIndexRoute
  '/_authenticated/operations/personnel/': typeof AuthenticatedOperationsPersonnelIndexRoute
  '/_authenticated/products/_layout/': typeof AuthenticatedProductsLayoutIndexRoute
  '/_authenticated/sales/sellers/': typeof AuthenticatedSalesSellersIndexRoute
  '/_authenticated/services/_layout/': typeof AuthenticatedServicesLayoutIndexRoute
  '/_authenticated/settings/_layout/': typeof AuthenticatedSettingsLayoutIndexRoute
  '/_public/s/$slug/': typeof PublicSSlugIndexRoute
  '/_super/super/apps/': typeof SuperSuperAppsIndexRoute
  '/_authenticated/collections/$collectionId/records/$recordId': typeof AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute
  '/_authenticated/collections/$collectionId/records/new': typeof AuthenticatedCollectionsCollectionIdRecordsNewRoute
  '/_authenticated/documents/records/$id/edit': typeof AuthenticatedDocumentsRecordsIdEditRoute
  '/_authenticated/documents/templates/$id/edit': typeof AuthenticatedDocumentsTemplatesIdEditRoute
  '/_authenticated/invoices/credit-notes/$creditNoteId/edit': typeof AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute
  '/_authenticated/invoices/debit-notes/$debitNoteId/edit': typeof AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute
  '/_authenticated/operations/work-orders/_list/calendar': typeof AuthenticatedOperationsWorkOrdersListCalendarRoute
  '/_authenticated/operations/work-orders/_list/mine': typeof AuthenticatedOperationsWorkOrdersListMineRoute
  '/_authenticated/operations/work-orders/_list/table': typeof AuthenticatedOperationsWorkOrdersListTableRoute
  '/_authenticated/operations/work-orders/_list/week': typeof AuthenticatedOperationsWorkOrdersListWeekRoute
  '/_authenticated/products/_layout/$id/edit': typeof AuthenticatedProductsLayoutIdEditRoute
  '/_authenticated/services/_layout/$id/edit': typeof AuthenticatedServicesLayoutIdEditRoute
  '/_authenticated/settings/_layout/apps/$listingId': typeof AuthenticatedSettingsLayoutAppsListingIdRoute
  '/_authenticated/settings/_layout/apps/publish': typeof AuthenticatedSettingsLayoutAppsPublishRoute
  '/_authenticated/settings/_layout/collections/schema': typeof AuthenticatedSettingsLayoutCollectionsSchemaRoute
  '/_authenticated/settings/_layout/email-templates/$templateId': typeof AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute
  '/_authenticated/settings/_layout/integrations/$connectionId': typeof AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute
  '/_authenticated/settings/_layout/invoices/credit-notes': typeof AuthenticatedSettingsLayoutInvoicesCreditNotesRoute
  '/_authenticated/settings/_layout/invoices/debit-notes': typeof AuthenticatedSettingsLayoutInvoicesDebitNotesRoute
  '/_authenticated/settings/_layout/invoices/exempts': typeof AuthenticatedSettingsLayoutInvoicesExemptsRoute
  '/_authenticated/settings/_layout/pdf-templates/$templateId': typeof AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute
  '/_authenticated/settings/_layout/scripts/$scriptId': typeof AuthenticatedSettingsLayoutScriptsScriptIdRoute
  '/_authenticated/settings/_layout/sites/$siteKey': typeof AuthenticatedSettingsLayoutSitesSiteKeyRoute
  '/_super/super/control-panel/$companyId/history': typeof SuperSuperControlPanelCompanyIdHistoryRoute
  '/_super/super/control-panel/$companyId/overview': typeof SuperSuperControlPanelCompanyIdOverviewRoute
  '/_super/super/control-panel/$companyId/subscription': typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  '/_super/super/control-panel/$companyId/usage': typeof SuperSuperControlPanelCompanyIdUsageRoute
  '/_super/super/control-panel/$companyId/users': typeof SuperSuperControlPanelCompanyIdUsersRoute
  '/_authenticated/invoices/credit-notes/$creditNoteId/': typeof AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute
  '/_authenticated/invoices/debit-notes/$debitNoteId/': typeof AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute
  '/_authenticated/operations/work-orders/_list/': typeof AuthenticatedOperationsWorkOrdersListIndexRoute
  '/_authenticated/settings/_layout/agents/': typeof AuthenticatedSettingsLayoutAgentsIndexRoute
  '/_authenticated/settings/_layout/apps/': typeof AuthenticatedSettingsLayoutAppsIndexRoute
  '/_authenticated/settings/_layout/collections/': typeof AuthenticatedSettingsLayoutCollectionsIndexRoute
  '/_authenticated/settings/_layout/integrations/': typeof AuthenticatedSettingsLayoutIntegrationsIndexRoute
  '/_authenticated/settings/_layout/inventory/': typeof AuthenticatedSettingsLayoutInventoryIndexRoute
  '/_authenticated/settings/_layout/invoices/': typeof AuthenticatedSettingsLayoutInvoicesIndexRoute
  '/_authenticated/settings/_layout/scripts/': typeof AuthenticatedSettingsLayoutScriptsIndexRoute
  '/_authenticated/settings/_layout/sites/': typeof AuthenticatedSettingsLayoutSitesIndexRoute
  '/_authenticated/settings/_layout/collections/config/$collectionId': typeof AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/clients'
    | '/collections'
    | '/complete-profile'
    | '/dashboard'
    | '/documents'
    | '/invoices'
    | '/operations'
    | '/profile'
    | '/quotations'
    | '/release-notes'
    | '/reports'
    | '/sales'
    | '/subscription-success'
    | '/subscriptions'
    | '/suppliers'
    | '/waitlist'
    | '/activate'
    | '/licenses'
    | '/setup'
    | '/crdt-playground'
    | '/ai'
    | '/collections/$collectionId'
    | '/inventory-counts/new'
    | '/inventory/movements'
    | '/invoices/new'
    | '/operations/personnel-roles'
    | '/products'
    | '/purchase-orders/new'
    | '/quotations/new'
    | '/sales/new'
    | '/services'
    | '/settings'
    | '/stock-transfers/new'
    | '/auth/first-time-login'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-in-with-otp'
    | '/auth/sign-up'
    | '/super'
    | '/super/companies'
    | '/super/dashboard'
    | '/super/licenses'
    | '/super/plans'
    | '/super/releases'
    | '/super/subscriptions'
    | '/super/users'
    | '/super/waitlist'
    | '/clients/'
    | '/documents/'
    | '/inventory-counts/'
    | '/inventory/'
    | '/invoices/'
    | '/purchase-orders/'
    | '/quotations/'
    | '/reports/'
    | '/sales/'
    | '/stock-transfers/'
    | '/suppliers/'
    | '/ai/insights'
    | '/collections/$collectionId/calendar'
    | '/collections/$collectionId/kanban'
    | '/collections/$collectionId/table'
    | '/documents/templates/new'
    | '/inventory-counts/$id/edit'
    | '/invoices/$id/edit'
    | '/invoices/credit-notes/new'
    | '/invoices/debit-notes/new'
    | '/operations/work-orders/$id'
    | '/operations/work-orders'
    | '/products/new'
    | '/purchase-orders/$id/edit'
    | '/quotations/$code/edit'
    | '/reports/$id/builder'
    | '/sales/$id/edit'
    | '/services/new'
    | '/settings/ai'
    | '/settings/branches'
    | '/settings/catalogs'
    | '/settings/companies'
    | '/settings/correlatives'
    | '/settings/migrations'
    | '/settings/nomenclatures'
    | '/settings/notifications'
    | '/settings/roles'
    | '/settings/schema'
    | '/settings/security'
    | '/settings/subscription'
    | '/settings/trash'
    | '/settings/users'
    | '/settings/warehouses'
    | '/stock-transfers/$id/edit'
    | '/s/$slug/$page'
    | '/shared/dashboards/$token'
    | '/shared/invoices/$id'
    | '/shared/quotations/$id'
    | '/shared/sales/$id'
    | '/super/apps/$versionId'
    | '/super/control-panel/$companyId'
    | '/ai/'
    | '/collections/$collectionId/'
    | '/invoices/cancelations/'
    | '/invoices/credit-notes/'
    | '/invoices/credits/'
    | '/invoices/debit-notes/'
    | '/invoices/exemptions/'
    | '/invoices/payments/'
    | '/operations/equipment/'
    | '/operations/personnel/'
    | '/products/'
    | '/sales/sellers/'
    | '/services/'
    | '/settings/'
    | '/s/$slug/'
    | '/super/apps/'
    | '/collections/$collectionId/records/$recordId'
    | '/collections/$collectionId/records/new'
    | '/documents/records/$id/edit'
    | '/documents/templates/$id/edit'
    | '/invoices/credit-notes/$creditNoteId/edit'
    | '/invoices/debit-notes/$debitNoteId/edit'
    | '/operations/work-orders/calendar'
    | '/operations/work-orders/mine'
    | '/operations/work-orders/table'
    | '/operations/work-orders/week'
    | '/products/$id/edit'
    | '/services/$id/edit'
    | '/settings/apps/$listingId'
    | '/settings/apps/publish'
    | '/settings/collections/schema'
    | '/settings/email-templates/$templateId'
    | '/settings/integrations/$connectionId'
    | '/settings/invoices/credit-notes'
    | '/settings/invoices/debit-notes'
    | '/settings/invoices/exempts'
    | '/settings/pdf-templates/$templateId'
    | '/settings/scripts/$scriptId'
    | '/settings/sites/$siteKey'
    | '/super/control-panel/$companyId/history'
    | '/super/control-panel/$companyId/overview'
    | '/super/control-panel/$companyId/subscription'
    | '/super/control-panel/$companyId/usage'
    | '/super/control-panel/$companyId/users'
    | '/invoices/credit-notes/$creditNoteId/'
    | '/invoices/debit-notes/$debitNoteId/'
    | '/operations/work-orders/'
    | '/settings/agents/'
    | '/settings/apps/'
    | '/settings/collections/'
    | '/settings/integrations/'
    | '/settings/inventory/'
    | '/settings/invoices/'
    | '/settings/scripts/'
    | '/settings/sites/'
    | '/settings/collections/config/$collectionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/collections'
    | '/complete-profile'
    | '/dashboard'
    | '/operations'
    | '/profile'
    | '/release-notes'
    | '/subscription-success'
    | '/subscriptions'
    | '/waitlist'
    | '/activate'
    | '/licenses'
    | '/setup'
    | '/crdt-playground'
    | '/inventory-counts/new'
    | '/inventory/movements'
    | '/invoices/new'
    | '/operations/personnel-roles'
    | '/purchase-orders/new'
    | '/quotations/new'
    | '/sales/new'
    | '/stock-transfers/new'
    | '/auth/first-time-login'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-in-with-otp'
    | '/auth/sign-up'
    | '/super'
    | '/super/companies'
    | '/super/dashboard'
    | '/super/licenses'
    | '/super/plans'
    | '/super/releases'
    | '/super/subscriptions'
    | '/super/users'
    | '/super/waitlist'
    | '/clients'
    | '/documents'
    | '/inventory-counts'
    | '/inventory'
    | '/invoices'
    | '/purchase-orders'
    | '/quotations'
    | '/reports'
    | '/sales'
    | '/stock-transfers'
    | '/suppliers'
    | '/ai/insights'
    | '/collections/$collectionId/calendar'
    | '/collections/$collectionId/kanban'
    | '/collections/$collectionId/table'
    | '/documents/templates/new'
    | '/inventory-counts/$id/edit'
    | '/invoices/$id/edit'
    | '/invoices/credit-notes/new'
    | '/invoices/debit-notes/new'
    | '/operations/work-orders/$id'
    | '/products/new'
    | '/purchase-orders/$id/edit'
    | '/quotations/$code/edit'
    | '/reports/$id/builder'
    | '/sales/$id/edit'
    | '/services/new'
    | '/settings/ai'
    | '/settings/branches'
    | '/settings/catalogs'
    | '/settings/companies'
    | '/settings/correlatives'
    | '/settings/migrations'
    | '/settings/nomenclatures'
    | '/settings/notifications'
    | '/settings/roles'
    | '/settings/schema'
    | '/settings/security'
    | '/settings/subscription'
    | '/settings/trash'
    | '/settings/users'
    | '/settings/warehouses'
    | '/stock-transfers/$id/edit'
    | '/s/$slug/$page'
    | '/shared/dashboards/$token'
    | '/shared/invoices/$id'
    | '/shared/quotations/$id'
    | '/shared/sales/$id'
    | '/super/apps/$versionId'
    | '/super/control-panel/$companyId'
    | '/ai'
    | '/collections/$collectionId'
    | '/invoices/cancelations'
    | '/invoices/credit-notes'
    | '/invoices/credits'
    | '/invoices/debit-notes'
    | '/invoices/exemptions'
    | '/invoices/payments'
    | '/operations/equipment'
    | '/operations/personnel'
    | '/products'
    | '/sales/sellers'
    | '/services'
    | '/settings'
    | '/s/$slug'
    | '/super/apps'
    | '/collections/$collectionId/records/$recordId'
    | '/collections/$collectionId/records/new'
    | '/documents/records/$id/edit'
    | '/documents/templates/$id/edit'
    | '/invoices/credit-notes/$creditNoteId/edit'
    | '/invoices/debit-notes/$debitNoteId/edit'
    | '/operations/work-orders/calendar'
    | '/operations/work-orders/mine'
    | '/operations/work-orders/table'
    | '/operations/work-orders/week'
    | '/products/$id/edit'
    | '/services/$id/edit'
    | '/settings/apps/$listingId'
    | '/settings/apps/publish'
    | '/settings/collections/schema'
    | '/settings/email-templates/$templateId'
    | '/settings/integrations/$connectionId'
    | '/settings/invoices/credit-notes'
    | '/settings/invoices/debit-notes'
    | '/settings/invoices/exempts'
    | '/settings/pdf-templates/$templateId'
    | '/settings/scripts/$scriptId'
    | '/settings/sites/$siteKey'
    | '/super/control-panel/$companyId/history'
    | '/super/control-panel/$companyId/overview'
    | '/super/control-panel/$companyId/subscription'
    | '/super/control-panel/$companyId/usage'
    | '/super/control-panel/$companyId/users'
    | '/invoices/credit-notes/$creditNoteId'
    | '/invoices/debit-notes/$debitNoteId'
    | '/operations/work-orders'
    | '/settings/agents'
    | '/settings/apps'
    | '/settings/collections'
    | '/settings/integrations'
    | '/settings/inventory'
    | '/settings/invoices'
    | '/settings/scripts'
    | '/settings/sites'
    | '/settings/collections/config/$collectionId'
  id:
    | '__root__'
    | '/$'
    | '/_authenticated'
    | '/_home'
    | '/_public'
    | '/_super'
    | '/_authenticated/clients'
    | '/_authenticated/collections'
    | '/_authenticated/complete-profile'
    | '/_authenticated/dashboard'
    | '/_authenticated/documents'
    | '/_authenticated/invoices'
    | '/_authenticated/operations'
    | '/_authenticated/profile'
    | '/_authenticated/quotations'
    | '/_authenticated/release-notes'
    | '/_authenticated/reports'
    | '/_authenticated/sales'
    | '/_authenticated/subscription-success'
    | '/_authenticated/subscriptions'
    | '/_authenticated/suppliers'
    | '/_home/waitlist'
    | '/_public/activate'
    | '/_public/licenses'
    | '/_public/setup'
    | '/_home/'
    | '/_authenticated/_dev/crdt-playground'
    | '/_authenticated/ai/_layout'
    | '/_authenticated/collections/$collectionId'
    | '/_authenticated/inventory-counts/new'
    | '/_authenticated/inventory/movements'
    | '/_authenticated/invoices/new'
    | '/_authenticated/operations/personnel-roles'
    | '/_authenticated/products/_layout'
    | '/_authenticated/purchase-orders/new'
    | '/_authenticated/quotations/new'
    | '/_authenticated/sales/new'
    | '/_authenticated/services/_layout'
    | '/_authenticated/settings/_layout'
    | '/_authenticated/stock-transfers/new'
    | '/_public/auth/first-time-login'
    | '/_public/auth/reset-password'
    | '/_public/auth/sign-in'
    | '/_public/auth/sign-in-with-otp'
    | '/_public/auth/sign-up'
    | '/_super/super/_layout'
    | '/_super/super/companies'
    | '/_super/super/dashboard'
    | '/_super/super/licenses'
    | '/_super/super/plans'
    | '/_super/super/releases'
    | '/_super/super/subscriptions'
    | '/_super/super/users'
    | '/_super/super/waitlist'
    | '/_authenticated/clients/'
    | '/_authenticated/documents/'
    | '/_authenticated/inventory-counts/'
    | '/_authenticated/inventory/'
    | '/_authenticated/invoices/'
    | '/_authenticated/purchase-orders/'
    | '/_authenticated/quotations/'
    | '/_authenticated/reports/'
    | '/_authenticated/sales/'
    | '/_authenticated/stock-transfers/'
    | '/_authenticated/suppliers/'
    | '/_authenticated/ai/_layout/insights'
    | '/_authenticated/collections/$collectionId/calendar'
    | '/_authenticated/collections/$collectionId/kanban'
    | '/_authenticated/collections/$collectionId/table'
    | '/_authenticated/documents/templates/new'
    | '/_authenticated/inventory-counts/$id/edit'
    | '/_authenticated/invoices/$id/edit'
    | '/_authenticated/invoices/credit-notes/new'
    | '/_authenticated/invoices/debit-notes/new'
    | '/_authenticated/operations/work-orders/$id'
    | '/_authenticated/operations/work-orders/_list'
    | '/_authenticated/products/_layout/new'
    | '/_authenticated/purchase-orders/$id/edit'
    | '/_authenticated/quotations/$code/edit'
    | '/_authenticated/reports/$id/builder'
    | '/_authenticated/sales/$id/edit'
    | '/_authenticated/services/_layout/new'
    | '/_authenticated/settings/_layout/ai'
    | '/_authenticated/settings/_layout/branches'
    | '/_authenticated/settings/_layout/catalogs'
    | '/_authenticated/settings/_layout/companies'
    | '/_authenticated/settings/_layout/correlatives'
    | '/_authenticated/settings/_layout/migrations'
    | '/_authenticated/settings/_layout/nomenclatures'
    | '/_authenticated/settings/_layout/notifications'
    | '/_authenticated/settings/_layout/roles'
    | '/_authenticated/settings/_layout/schema'
    | '/_authenticated/settings/_layout/security'
    | '/_authenticated/settings/_layout/subscription'
    | '/_authenticated/settings/_layout/trash'
    | '/_authenticated/settings/_layout/users'
    | '/_authenticated/settings/_layout/warehouses'
    | '/_authenticated/stock-transfers/$id/edit'
    | '/_public/s/$slug/$page'
    | '/_public/shared/dashboards/$token'
    | '/_public/shared/invoices/$id'
    | '/_public/shared/quotations/$id'
    | '/_public/shared/sales/$id'
    | '/_super/super/apps/$versionId'
    | '/_super/super/control-panel/$companyId'
    | '/_authenticated/ai/_layout/'
    | '/_authenticated/collections/$collectionId/'
    | '/_authenticated/invoices/cancelations/'
    | '/_authenticated/invoices/credit-notes/'
    | '/_authenticated/invoices/credits/'
    | '/_authenticated/invoices/debit-notes/'
    | '/_authenticated/invoices/exemptions/'
    | '/_authenticated/invoices/payments/'
    | '/_authenticated/operations/equipment/'
    | '/_authenticated/operations/personnel/'
    | '/_authenticated/products/_layout/'
    | '/_authenticated/sales/sellers/'
    | '/_authenticated/services/_layout/'
    | '/_authenticated/settings/_layout/'
    | '/_public/s/$slug/'
    | '/_super/super/apps/'
    | '/_authenticated/collections/$collectionId/records/$recordId'
    | '/_authenticated/collections/$collectionId/records/new'
    | '/_authenticated/documents/records/$id/edit'
    | '/_authenticated/documents/templates/$id/edit'
    | '/_authenticated/invoices/credit-notes/$creditNoteId/edit'
    | '/_authenticated/invoices/debit-notes/$debitNoteId/edit'
    | '/_authenticated/operations/work-orders/_list/calendar'
    | '/_authenticated/operations/work-orders/_list/mine'
    | '/_authenticated/operations/work-orders/_list/table'
    | '/_authenticated/operations/work-orders/_list/week'
    | '/_authenticated/products/_layout/$id/edit'
    | '/_authenticated/services/_layout/$id/edit'
    | '/_authenticated/settings/_layout/apps/$listingId'
    | '/_authenticated/settings/_layout/apps/publish'
    | '/_authenticated/settings/_layout/collections/schema'
    | '/_authenticated/settings/_layout/email-templates/$templateId'
    | '/_authenticated/settings/_layout/integrations/$connectionId'
    | '/_authenticated/settings/_layout/invoices/credit-notes'
    | '/_authenticated/settings/_layout/invoices/debit-notes'
    | '/_authenticated/settings/_layout/invoices/exempts'
    | '/_authenticated/settings/_layout/pdf-templates/$templateId'
    | '/_authenticated/settings/_layout/scripts/$scriptId'
    | '/_authenticated/settings/_layout/sites/$siteKey'
    | '/_super/super/control-panel/$companyId/history'
    | '/_super/super/control-panel/$companyId/overview'
    | '/_super/super/control-panel/$companyId/subscription'
    | '/_super/super/control-panel/$companyId/usage'
    | '/_super/super/control-panel/$companyId/users'
    | '/_authenticated/invoices/credit-notes/$creditNoteId/'
    | '/_authenticated/invoices/debit-notes/$debitNoteId/'
    | '/_authenticated/operations/work-orders/_list/'
    | '/_authenticated/settings/_layout/agents/'
    | '/_authenticated/settings/_layout/apps/'
    | '/_authenticated/settings/_layout/collections/'
    | '/_authenticated/settings/_layout/integrations/'
    | '/_authenticated/settings/_layout/inventory/'
    | '/_authenticated/settings/_layout/invoices/'
    | '/_authenticated/settings/_layout/scripts/'
    | '/_authenticated/settings/_layout/sites/'
    | '/_authenticated/settings/_layout/collections/config/$collectionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  HomeRoute: typeof HomeRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SuperRoute: typeof SuperRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home': {
      id: '/_home'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_super': {
      id: '/_super'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SuperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/clients': {
      id: '/_authenticated/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedClientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/collections': {
      id: '/_authenticated/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AuthenticatedCollectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/complete-profile': {
      id: '/_authenticated/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof AuthenticatedCompleteProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices': {
      id: '/_authenticated/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedInvoicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/operations': {
      id: '/_authenticated/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthenticatedOperationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations': {
      id: '/_authenticated/quotations'
      path: '/quotations'
      fullPath: '/quotations'
      preLoaderRoute: typeof AuthenticatedQuotationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/release-notes': {
      id: '/_authenticated/release-notes'
      path: '/release-notes'
      fullPath: '/release-notes'
      preLoaderRoute: typeof AuthenticatedReleaseNotesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales': {
      id: '/_authenticated/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof AuthenticatedSalesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscription-success': {
      id: '/_authenticated/subscription-success'
      path: '/subscription-success'
      fullPath: '/subscription-success'
      preLoaderRoute: typeof AuthenticatedSubscriptionSuccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscriptions': {
      id: '/_authenticated/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthenticatedSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers': {
      id: '/_authenticated/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AuthenticatedSuppliersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/waitlist': {
      id: '/_home/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof HomeWaitlistRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_public/activate': {
      id: '/_public/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof PublicActivateRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/licenses': {
      id: '/_public/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof PublicLicensesRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/setup': {
      id: '/_public/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof PublicSetupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/_dev/crdt-playground': {
      id: '/_authenticated/_dev/crdt-playground'
      path: '/crdt-playground'
      fullPath: '/crdt-playground'
      preLoaderRoute: typeof AuthenticatedDevCrdtPlaygroundRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/_layout': {
      id: '/_authenticated/ai/_layout'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AuthenticatedAiLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedClientsRoute
    }
    '/_authenticated/collections/$collectionId': {
      id: '/_authenticated/collections/$collectionId'
      path: '/$collectionId'
      fullPath: '/collections/$collectionId'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdRouteImport
      parentRoute: typeof AuthenticatedCollectionsRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/inventory-counts/': {
      id: '/_authenticated/inventory-counts/'
      path: '/inventory-counts'
      fullPath: '/inventory-counts/'
      preLoaderRoute: typeof AuthenticatedInventoryCountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory-counts/new': {
      id: '/_authenticated/inventory-counts/new'
      path: '/inventory-counts/new'
      fullPath: '/inventory-counts/new'
      preLoaderRoute: typeof AuthenticatedInventoryCountsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/': {
      id: '/_authenticated/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AuthenticatedInventoryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/movements': {
      id: '/_authenticated/inventory/movements'
      path: '/inventory/movements'
      fullPath: '/inventory/movements'
      preLoaderRoute: typeof AuthenticatedInventoryMovementsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/new': {
      id: '/_authenticated/invoices/new'
      path: '/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthenticatedInvoicesNewRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/operations/personnel-roles': {
      id: '/_authenticated/operations/personnel-roles'
      path: '/personnel-roles'
      fullPath: '/operations/personnel-roles'
      preLoaderRoute: typeof AuthenticatedOperationsPersonnelRolesRouteImport
      parentRoute: typeof AuthenticatedOperationsRoute
    }
    '/_authenticated/products/_layout': {
      id: '/_authenticated/products/_layout'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedProductsLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchase-orders/': {
      id: '/_authenticated/purchase-orders/'
      path: '/purchase-orders'
      fullPath: '/purchase-orders/'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchase-orders/new': {
      id: '/_authenticated/purchase-orders/new'
      path: '/purchase-orders/new'
      fullPath: '/purchase-orders/new'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations/': {
      id: '/_authenticated/quotations/'
      path: '/'
      fullPath: '/quotations/'
      preLoaderRoute: typeof AuthenticatedQuotationsIndexRouteImport
      parentRoute: typeof AuthenticatedQuotationsRoute
    }
    '/_authenticated/quotations/new': {
      id: '/_authenticated/quotations/new'
      path: '/new'
      fullPath: '/quotations/new'
      preLoaderRoute: typeof AuthenticatedQuotationsNewRouteImport
      parentRoute: typeof AuthenticatedQuotationsRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/sales/': {
      id: '/_authenticated/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof AuthenticatedSalesIndexRouteImport
      parentRoute: typeof AuthenticatedSalesRoute
    }
    '/_authenticated/sales/new': {
      id: '/_authenticated/sales/new'
      path: '/new'
      fullPath: '/sales/new'
      preLoaderRoute: typeof AuthenticatedSalesNewRouteImport
      parentRoute: typeof AuthenticatedSalesRoute
    }
    '/_authenticated/services/_layout': {
      id: '/_authenticated/services/_layout'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AuthenticatedServicesLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/_layout': {
      id: '/_authenticated/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stock-transfers/': {
      id: '/_authenticated/stock-transfers/'
      path: '/stock-transfers'
      fullPath: '/stock-transfers/'
      preLoaderRoute: typeof AuthenticatedStockTransfersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stock-transfers/new': {
      id: '/_authenticated/stock-transfers/new'
      path: '/stock-transfers/new'
      fullPath: '/stock-transfers/new'
      preLoaderRoute: typeof AuthenticatedStockTransfersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/': {
      id: '/_authenticated/suppliers/'
      path: '/'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AuthenticatedSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedSuppliersRoute
    }
    '/_public/auth/first-time-login': {
      id: '/_public/auth/first-time-login'
      path: '/auth/first-time-login'
      fullPath: '/auth/first-time-login'
      preLoaderRoute: typeof PublicAuthFirstTimeLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/reset-password': {
      id: '/_public/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof PublicAuthResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/sign-in': {
      id: '/_public/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof PublicAuthSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/sign-in-with-otp': {
      id: '/_public/auth/sign-in-with-otp'
      path: '/auth/sign-in-with-otp'
      fullPath: '/auth/sign-in-with-otp'
      preLoaderRoute: typeof PublicAuthSignInWithOtpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/sign-up': {
      id: '/_public/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof PublicAuthSignUpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_super/super/_layout': {
      id: '/_super/super/_layout'
      path: '/super'
      fullPath: '/super'
      preLoaderRoute: typeof SuperSuperLayoutRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/companies': {
      id: '/_super/super/companies'
      path: '/super/companies'
      fullPath: '/super/companies'
      preLoaderRoute: typeof SuperSuperCompaniesRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/dashboard': {
      id: '/_super/super/dashboard'
      path: '/super/dashboard'
      fullPath: '/super/dashboard'
      preLoaderRoute: typeof SuperSuperDashboardRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/licenses': {
      id: '/_super/super/licenses'
      path: '/super/licenses'
      fullPath: '/super/licenses'
      preLoaderRoute: typeof SuperSuperLicensesRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/plans': {
      id: '/_super/super/plans'
      path: '/super/plans'
      fullPath: '/super/plans'
      preLoaderRoute: typeof SuperSuperPlansRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/releases': {
      id: '/_super/super/releases'
      path: '/super/releases'
      fullPath: '/super/releases'
      preLoaderRoute: typeof SuperSuperReleasesRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/subscriptions': {
      id: '/_super/super/subscriptions'
      path: '/super/subscriptions'
      fullPath: '/super/subscriptions'
      preLoaderRoute: typeof SuperSuperSubscriptionsRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/users': {
      id: '/_super/super/users'
      path: '/super/users'
      fullPath: '/super/users'
      preLoaderRoute: typeof SuperSuperUsersRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/waitlist': {
      id: '/_super/super/waitlist'
      path: '/super/waitlist'
      fullPath: '/super/waitlist'
      preLoaderRoute: typeof SuperSuperWaitlistRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_authenticated/ai/_layout/': {
      id: '/_authenticated/ai/_layout/'
      path: '/'
      fullPath: '/ai/'
      preLoaderRoute: typeof AuthenticatedAiLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedAiLayoutRoute
    }
    '/_authenticated/ai/_layout/insights': {
      id: '/_authenticated/ai/_layout/insights'
      path: '/insights'
      fullPath: '/ai/insights'
      preLoaderRoute: typeof AuthenticatedAiLayoutInsightsRouteImport
      parentRoute: typeof AuthenticatedAiLayoutRoute
    }
    '/_authenticated/collections/$collectionId/': {
      id: '/_authenticated/collections/$collectionId/'
      path: '/'
      fullPath: '/collections/$collectionId/'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdIndexRouteImport
      parentRoute: typeof AuthenticatedCollectionsCollectionIdRoute
    }
    '/_authenticated/collections/$collectionId/calendar': {
      id: '/_authenticated/collections/$collectionId/calendar'
      path: '/calendar'
      fullPath: '/collections/$collectionId/calendar'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdCalendarRouteImport
      parentRoute: typeof AuthenticatedCollectionsCollectionIdRoute
    }
    '/_authenticated/collections/$collectionId/kanban': {
      id: '/_authenticated/collections/$collectionId/kanban'
      path: '/kanban'
      fullPath: '/collections/$collectionId/kanban'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdKanbanRouteImport
      parentRoute: typeof AuthenticatedCollectionsCollectionIdRoute
    }
    '/_authenticated/collections/$collectionId/table': {
      id: '/_authenticated/collections/$collectionId/table'
      path: '/table'
      fullPath: '/collections/$collectionId/table'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdTableRouteImport
      parentRoute: typeof AuthenticatedCollectionsCollectionIdRoute
    }
    '/_authenticated/documents/templates/new': {
      id: '/_authenticated/documents/templates/new'
      path: '/templates/new'
      fullPath: '/documents/templates/new'
      preLoaderRoute: typeof AuthenticatedDocumentsTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/inventory-counts/$id/edit': {
      id: '/_authenticated/inventory-counts/$id/edit'
      path: '/inventory-counts/$id/edit'
      fullPath: '/inventory-counts/$id/edit'
      preLoaderRoute: typeof AuthenticatedInventoryCountsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/$id/edit': {
      id: '/_authenticated/invoices/$id/edit'
      path: '/$id/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof AuthenticatedInvoicesIdEditRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/cancelations/': {
      id: '/_authenticated/invoices/cancelations/'
      path: '/cancelations'
      fullPath: '/invoices/cancelations/'
      preLoaderRoute: typeof AuthenticatedInvoicesCancelationsIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/credit-notes/': {
      id: '/_authenticated/invoices/credit-notes/'
      path: '/credit-notes'
      fullPath: '/invoices/credit-notes/'
      preLoaderRoute: typeof AuthenticatedInvoicesCreditNotesIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/credit-notes/new': {
      id: '/_authenticated/invoices/credit-notes/new'
      path: '/credit-notes/new'
      fullPath: '/invoices/credit-notes/new'
      preLoaderRoute: typeof AuthenticatedInvoicesCreditNotesNewRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/credits/': {
      id: '/_authenticated/invoices/credits/'
      path: '/credits'
      fullPath: '/invoices/credits/'
      preLoaderRoute: typeof AuthenticatedInvoicesCreditsIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/debit-notes/': {
      id: '/_authenticated/invoices/debit-notes/'
      path: '/debit-notes'
      fullPath: '/invoices/debit-notes/'
      preLoaderRoute: typeof AuthenticatedInvoicesDebitNotesIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/debit-notes/new': {
      id: '/_authenticated/invoices/debit-notes/new'
      path: '/debit-notes/new'
      fullPath: '/invoices/debit-notes/new'
      preLoaderRoute: typeof AuthenticatedInvoicesDebitNotesNewRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/exemptions/': {
      id: '/_authenticated/invoices/exemptions/'
      path: '/exemptions'
      fullPath: '/invoices/exemptions/'
      preLoaderRoute: typeof AuthenticatedInvoicesExemptionsIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/payments/': {
      id: '/_authenticated/invoices/payments/'
      path: '/payments'
      fullPath: '/invoices/payments/'
      preLoaderRoute: typeof AuthenticatedInvoicesPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/operations/equipment/': {
      id: '/_authenticated/operations/equipment/'
      path: '/equipment'
      fullPath: '/operations/equipment/'
      preLoaderRoute: typeof AuthenticatedOperationsEquipmentIndexRouteImport
      parentRoute: typeof AuthenticatedOperationsRoute
    }
    '/_authenticated/operations/personnel/': {
      id: '/_authenticated/operations/personnel/'
      path: '/personnel'
      fullPath: '/operations/personnel/'
      preLoaderRoute: typeof AuthenticatedOperationsPersonnelIndexRouteImport
      parentRoute: typeof AuthenticatedOperationsRoute
    }
    '/_authenticated/operations/work-orders/$id': {
      id: '/_authenticated/operations/work-orders/$id'
      path: '/work-orders/$id'
      fullPath: '/operations/work-orders/$id'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersIdRouteImport
      parentRoute: typeof AuthenticatedOperationsRoute
    }
    '/_authenticated/operations/work-orders/_list': {
      id: '/_authenticated/operations/work-orders/_list'
      path: '/work-orders'
      fullPath: '/operations/work-orders'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersListRouteImport
      parentRoute: typeof AuthenticatedOperationsRoute
    }
    '/_authenticated/products/_layout/': {
      id: '/_authenticated/products/_layout/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedProductsLayoutRoute
    }
    '/_authenticated/products/_layout/new': {
      id: '/_authenticated/products/_layout/new'
      path: '/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AuthenticatedProductsLayoutNewRouteImport
      parentRoute: typeof AuthenticatedProductsLayoutRoute
    }
    '/_authenticated/purchase-orders/$id/edit': {
      id: '/_authenticated/purchase-orders/$id/edit'
      path: '/purchase-orders/$id/edit'
      fullPath: '/purchase-orders/$id/edit'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations/$code/edit': {
      id: '/_authenticated/quotations/$code/edit'
      path: '/$code/edit'
      fullPath: '/quotations/$code/edit'
      preLoaderRoute: typeof AuthenticatedQuotationsCodeEditRouteImport
      parentRoute: typeof AuthenticatedQuotationsRoute
    }
    '/_authenticated/reports/$id/builder': {
      id: '/_authenticated/reports/$id/builder'
      path: '/$id/builder'
      fullPath: '/reports/$id/builder'
      preLoaderRoute: typeof AuthenticatedReportsIdBuilderRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/sales/$id/edit': {
      id: '/_authenticated/sales/$id/edit'
      path: '/$id/edit'
      fullPath: '/sales/$id/edit'
      preLoaderRoute: typeof AuthenticatedSalesIdEditRouteImport
      parentRoute: typeof AuthenticatedSalesRoute
    }
    '/_authenticated/sales/sellers/': {
      id: '/_authenticated/sales/sellers/'
      path: '/sellers'
      fullPath: '/sales/sellers/'
      preLoaderRoute: typeof AuthenticatedSalesSellersIndexRouteImport
      parentRoute: typeof AuthenticatedSalesRoute
    }
    '/_authenticated/services/_layout/': {
      id: '/_authenticated/services/_layout/'
      path: '/'
      fullPath: '/services/'
      preLoaderRoute: typeof AuthenticatedServicesLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedServicesLayoutRoute
    }
    '/_authenticated/services/_layout/new': {
      id: '/_authenticated/services/_layout/new'
      path: '/new'
      fullPath: '/services/new'
      preLoaderRoute: typeof AuthenticatedServicesLayoutNewRouteImport
      parentRoute: typeof AuthenticatedServicesLayoutRoute
    }
    '/_authenticated/settings/_layout/': {
      id: '/_authenticated/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/ai': {
      id: '/_authenticated/settings/_layout/ai'
      path: '/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutAiRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/branches': {
      id: '/_authenticated/settings/_layout/branches'
      path: '/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutBranchesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/catalogs': {
      id: '/_authenticated/settings/_layout/catalogs'
      path: '/catalogs'
      fullPath: '/settings/catalogs'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCatalogsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/companies': {
      id: '/_authenticated/settings/_layout/companies'
      path: '/companies'
      fullPath: '/settings/companies'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCompaniesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/correlatives': {
      id: '/_authenticated/settings/_layout/correlatives'
      path: '/correlatives'
      fullPath: '/settings/correlatives'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCorrelativesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/migrations': {
      id: '/_authenticated/settings/_layout/migrations'
      path: '/migrations'
      fullPath: '/settings/migrations'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutMigrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/nomenclatures': {
      id: '/_authenticated/settings/_layout/nomenclatures'
      path: '/nomenclatures'
      fullPath: '/settings/nomenclatures'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutNomenclaturesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/notifications': {
      id: '/_authenticated/settings/_layout/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/roles': {
      id: '/_authenticated/settings/_layout/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutRolesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/schema': {
      id: '/_authenticated/settings/_layout/schema'
      path: '/schema'
      fullPath: '/settings/schema'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutSchemaRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/security': {
      id: '/_authenticated/settings/_layout/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/subscription': {
      id: '/_authenticated/settings/_layout/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutSubscriptionRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/trash': {
      id: '/_authenticated/settings/_layout/trash'
      path: '/trash'
      fullPath: '/settings/trash'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutTrashRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/users': {
      id: '/_authenticated/settings/_layout/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/warehouses': {
      id: '/_authenticated/settings/_layout/warehouses'
      path: '/warehouses'
      fullPath: '/settings/warehouses'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutWarehousesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/stock-transfers/$id/edit': {
      id: '/_authenticated/stock-transfers/$id/edit'
      path: '/stock-transfers/$id/edit'
      fullPath: '/stock-transfers/$id/edit'
      preLoaderRoute: typeof AuthenticatedStockTransfersIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/s/$slug/': {
      id: '/_public/s/$slug/'
      path: '/s/$slug'
      fullPath: '/s/$slug/'
      preLoaderRoute: typeof PublicSSlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/s/$slug/$page': {
      id: '/_public/s/$slug/$page'
      path: '/s/$slug/$page'
      fullPath: '/s/$slug/$page'
      preLoaderRoute: typeof PublicSSlugPageRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/shared/dashboards/$token': {
      id: '/_public/shared/dashboards/$token'
      path: '/shared/dashboards/$token'
      fullPath: '/shared/dashboards/$token'
      preLoaderRoute: typeof PublicSharedDashboardsTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/shared/invoices/$id': {
      id: '/_public/shared/invoices/$id'
      path: '/shared/invoices/$id'
      fullPath: '/shared/invoices/$id'
      preLoaderRoute: typeof PublicSharedInvoicesIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/shared/quotations/$id': {
      id: '/_public/shared/quotations/$id'
      path: '/shared/quotations/$id'
      fullPath: '/shared/quotations/$id'
      preLoaderRoute: typeof PublicSharedQuotationsIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/shared/sales/$id': {
      id: '/_public/shared/sales/$id'
      path: '/shared/sales/$id'
      fullPath: '/shared/sales/$id'
      preLoaderRoute: typeof PublicSharedSalesIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_super/super/apps/': {
      id: '/_super/super/apps/'
      path: '/super/apps'
      fullPath: '/super/apps/'
      preLoaderRoute: typeof SuperSuperAppsIndexRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/apps/$versionId': {
      id: '/_super/super/apps/$versionId'
      path: '/super/apps/$versionId'
      fullPath: '/super/apps/$versionId'
      preLoaderRoute: typeof SuperSuperAppsVersionIdRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_super/super/control-panel/$companyId': {
      id: '/_super/super/control-panel/$companyId'
      path: '/super/control-panel/$companyId'
      fullPath: '/super/control-panel/$companyId'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdRouteImport
      parentRoute: typeof SuperRoute
    }
    '/_authenticated/collections/$collectionId/records/$recordId': {
      id: '/_authenticated/collections/$collectionId/records/$recordId'
      path: '/records/$recordId'
      fullPath: '/collections/$collectionId/records/$recordId'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdRecordsRecordIdRouteImport
      parentRoute: typeof AuthenticatedCollectionsCollectionIdRoute
    }
    '/_authenticated/collections/$collectionId/records/new': {
      id: '/_authenticated/collections/$collectionId/records/new'
      path: '/records/new'
      fullPath: '/collections/$collectionId/records/new'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdRecordsNewRouteImport
      parentRoute: typeof AuthenticatedCollectionsCollectionIdRoute
    }
    '/_authenticated/documents/records/$id/edit': {
      id: '/_authenticated/documents/records/$id/edit'
      path: '/records/$id/edit'
      fullPath: '/documents/records/$id/edit'
      preLoaderRoute: typeof AuthenticatedDocumentsRecordsIdEditRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/documents/templates/$id/edit': {
      id: '/_authenticated/documents/templates/$id/edit'
      path: '/templates/$id/edit'
      fullPath: '/documents/templates/$id/edit'
      preLoaderRoute: typeof AuthenticatedDocumentsTemplatesIdEditRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/invoices/credit-notes/$creditNoteId/': {
      id: '/_authenticated/invoices/credit-notes/$creditNoteId/'
      path: '/credit-notes/$creditNoteId'
      fullPath: '/invoices/credit-notes/$creditNoteId/'
      preLoaderRoute: typeof AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/credit-notes/$creditNoteId/edit': {
      id: '/_authenticated/invoices/credit-notes/$creditNoteId/edit'
      path: '/credit-notes/$creditNoteId/edit'
      fullPath: '/invoices/credit-notes/$creditNoteId/edit'
      preLoaderRoute: typeof AuthenticatedInvoicesCreditNotesCreditNoteIdEditRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/debit-notes/$debitNoteId/': {
      id: '/_authenticated/invoices/debit-notes/$debitNoteId/'
      path: '/debit-notes/$debitNoteId'
      fullPath: '/invoices/debit-notes/$debitNoteId/'
      preLoaderRoute: typeof AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/debit-notes/$debitNoteId/edit': {
      id: '/_authenticated/invoices/debit-notes/$debitNoteId/edit'
      path: '/debit-notes/$debitNoteId/edit'
      fullPath: '/invoices/debit-notes/$debitNoteId/edit'
      preLoaderRoute: typeof AuthenticatedInvoicesDebitNotesDebitNoteIdEditRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/operations/work-orders/_list/': {
      id: '/_authenticated/operations/work-orders/_list/'
      path: '/'
      fullPath: '/operations/work-orders/'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersListIndexRouteImport
      parentRoute: typeof AuthenticatedOperationsWorkOrdersListRoute
    }
    '/_authenticated/operations/work-orders/_list/calendar': {
      id: '/_authenticated/operations/work-orders/_list/calendar'
      path: '/calendar'
      fullPath: '/operations/work-orders/calendar'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersListCalendarRouteImport
      parentRoute: typeof AuthenticatedOperationsWorkOrdersListRoute
    }
    '/_authenticated/operations/work-orders/_list/mine': {
      id: '/_authenticated/operations/work-orders/_list/mine'
      path: '/mine'
      fullPath: '/operations/work-orders/mine'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersListMineRouteImport
      parentRoute: typeof AuthenticatedOperationsWorkOrdersListRoute
    }
    '/_authenticated/operations/work-orders/_list/table': {
      id: '/_authenticated/operations/work-orders/_list/table'
      path: '/table'
      fullPath: '/operations/work-orders/table'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersListTableRouteImport
      parentRoute: typeof AuthenticatedOperationsWorkOrdersListRoute
    }
    '/_authenticated/operations/work-orders/_list/week': {
      id: '/_authenticated/operations/work-orders/_list/week'
      path: '/week'
      fullPath: '/operations/work-orders/week'
      preLoaderRoute: typeof AuthenticatedOperationsWorkOrdersListWeekRouteImport
      parentRoute: typeof AuthenticatedOperationsWorkOrdersListRoute
    }
    '/_authenticated/products/_layout/$id/edit': {
      id: '/_authenticated/products/_layout/$id/edit'
      path: '/$id/edit'
      fullPath: '/products/$id/edit'
      preLoaderRoute: typeof AuthenticatedProductsLayoutIdEditRouteImport
      parentRoute: typeof AuthenticatedProductsLayoutRoute
    }
    '/_authenticated/services/_layout/$id/edit': {
      id: '/_authenticated/services/_layout/$id/edit'
      path: '/$id/edit'
      fullPath: '/services/$id/edit'
      preLoaderRoute: typeof AuthenticatedServicesLayoutIdEditRouteImport
      parentRoute: typeof AuthenticatedServicesLayoutRoute
    }
    '/_authenticated/settings/_layout/agents/': {
      id: '/_authenticated/settings/_layout/agents/'
      path: '/agents'
      fullPath: '/settings/agents/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/apps/': {
      id: '/_authenticated/settings/_layout/apps/'
      path: '/apps'
      fullPath: '/settings/apps/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutAppsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/apps/$listingId': {
      id: '/_authenticated/settings/_layout/apps/$listingId'
      path: '/apps/$listingId'
      fullPath: '/settings/apps/$listingId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutAppsListingIdRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/apps/publish': {
      id: '/_authenticated/settings/_layout/apps/publish'
      path: '/apps/publish'
      fullPath: '/settings/apps/publish'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutAppsPublishRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/collections/': {
      id: '/_authenticated/settings/_layout/collections/'
      path: '/collections'
      fullPath: '/settings/collections/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/collections/schema': {
      id: '/_authenticated/settings/_layout/collections/schema'
      path: '/collections/schema'
      fullPath: '/settings/collections/schema'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCollectionsSchemaRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/email-templates/$templateId': {
      id: '/_authenticated/settings/_layout/email-templates/$templateId'
      path: '/email-templates/$templateId'
      fullPath: '/settings/email-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/integrations/': {
      id: '/_authenticated/settings/_layout/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/integrations/$connectionId': {
      id: '/_authenticated/settings/_layout/integrations/$connectionId'
      path: '/integrations/$connectionId'
      fullPath: '/settings/integrations/$connectionId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutIntegrationsConnectionIdRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/inventory/': {
      id: '/_authenticated/settings/_layout/inventory/'
      path: '/inventory'
      fullPath: '/settings/inventory/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutInventoryIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/invoices/': {
      id: '/_authenticated/settings/_layout/invoices/'
      path: '/invoices'
      fullPath: '/settings/invoices/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/invoices/credit-notes': {
      id: '/_authenticated/settings/_layout/invoices/credit-notes'
      path: '/invoices/credit-notes'
      fullPath: '/settings/invoices/credit-notes'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutInvoicesCreditNotesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/invoices/debit-notes': {
      id: '/_authenticated/settings/_layout/invoices/debit-notes'
      path: '/invoices/debit-notes'
      fullPath: '/settings/invoices/debit-notes'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutInvoicesDebitNotesRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/invoices/exempts': {
      id: '/_authenticated/settings/_layout/invoices/exempts'
      path: '/invoices/exempts'
      fullPath: '/settings/invoices/exempts'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutInvoicesExemptsRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/pdf-templates/$templateId': {
      id: '/_authenticated/settings/_layout/pdf-templates/$templateId'
      path: '/pdf-templates/$templateId'
      fullPath: '/settings/pdf-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/scripts/': {
      id: '/_authenticated/settings/_layout/scripts/'
      path: '/scripts'
      fullPath: '/settings/scripts/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutScriptsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/scripts/$scriptId': {
      id: '/_authenticated/settings/_layout/scripts/$scriptId'
      path: '/scripts/$scriptId'
      fullPath: '/settings/scripts/$scriptId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutScriptsScriptIdRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/sites/': {
      id: '/_authenticated/settings/_layout/sites/'
      path: '/sites'
      fullPath: '/settings/sites/'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutSitesIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_authenticated/settings/_layout/sites/$siteKey': {
      id: '/_authenticated/settings/_layout/sites/$siteKey'
      path: '/sites/$siteKey'
      fullPath: '/settings/sites/$siteKey'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutSitesSiteKeyRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
    '/_super/super/control-panel/$companyId/history': {
      id: '/_super/super/control-panel/$companyId/history'
      path: '/history'
      fullPath: '/super/control-panel/$companyId/history'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdHistoryRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/overview': {
      id: '/_super/super/control-panel/$companyId/overview'
      path: '/overview'
      fullPath: '/super/control-panel/$companyId/overview'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdOverviewRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/subscription': {
      id: '/_super/super/control-panel/$companyId/subscription'
      path: '/subscription'
      fullPath: '/super/control-panel/$companyId/subscription'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdSubscriptionRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/usage': {
      id: '/_super/super/control-panel/$companyId/usage'
      path: '/usage'
      fullPath: '/super/control-panel/$companyId/usage'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdUsageRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_super/super/control-panel/$companyId/users': {
      id: '/_super/super/control-panel/$companyId/users'
      path: '/users'
      fullPath: '/super/control-panel/$companyId/users'
      preLoaderRoute: typeof SuperSuperControlPanelCompanyIdUsersRouteImport
      parentRoute: typeof SuperSuperControlPanelCompanyIdRoute
    }
    '/_authenticated/settings/_layout/collections/config/$collectionId': {
      id: '/_authenticated/settings/_layout/collections/config/$collectionId'
      path: '/collections/config/$collectionId'
      fullPath: '/settings/collections/config/$collectionId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRouteImport
      parentRoute: typeof AuthenticatedSettingsLayoutRoute
    }
  }
}

interface AuthenticatedClientsRouteChildren {
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
}

const AuthenticatedClientsRouteChildren: AuthenticatedClientsRouteChildren = {
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
}

const AuthenticatedClientsRouteWithChildren =
  AuthenticatedClientsRoute._addFileChildren(AuthenticatedClientsRouteChildren)

interface AuthenticatedCollectionsCollectionIdRouteChildren {
  AuthenticatedCollectionsCollectionIdCalendarRoute: typeof AuthenticatedCollectionsCollectionIdCalendarRoute
  AuthenticatedCollectionsCollectionIdKanbanRoute: typeof AuthenticatedCollectionsCollectionIdKanbanRoute
  AuthenticatedCollectionsCollectionIdTableRoute: typeof AuthenticatedCollectionsCollectionIdTableRoute
  AuthenticatedCollectionsCollectionIdIndexRoute: typeof AuthenticatedCollectionsCollectionIdIndexRoute
  AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute: typeof AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute
  AuthenticatedCollectionsCollectionIdRecordsNewRoute: typeof AuthenticatedCollectionsCollectionIdRecordsNewRoute
}

const AuthenticatedCollectionsCollectionIdRouteChildren: AuthenticatedCollectionsCollectionIdRouteChildren =
  {
    AuthenticatedCollectionsCollectionIdCalendarRoute:
      AuthenticatedCollectionsCollectionIdCalendarRoute,
    AuthenticatedCollectionsCollectionIdKanbanRoute:
      AuthenticatedCollectionsCollectionIdKanbanRoute,
    AuthenticatedCollectionsCollectionIdTableRoute:
      AuthenticatedCollectionsCollectionIdTableRoute,
    AuthenticatedCollectionsCollectionIdIndexRoute:
      AuthenticatedCollectionsCollectionIdIndexRoute,
    AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute:
      AuthenticatedCollectionsCollectionIdRecordsRecordIdRoute,
    AuthenticatedCollectionsCollectionIdRecordsNewRoute:
      AuthenticatedCollectionsCollectionIdRecordsNewRoute,
  }

const AuthenticatedCollectionsCollectionIdRouteWithChildren =
  AuthenticatedCollectionsCollectionIdRoute._addFileChildren(
    AuthenticatedCollectionsCollectionIdRouteChildren,
  )

interface AuthenticatedCollectionsRouteChildren {
  AuthenticatedCollectionsCollectionIdRoute: typeof AuthenticatedCollectionsCollectionIdRouteWithChildren
}

const AuthenticatedCollectionsRouteChildren: AuthenticatedCollectionsRouteChildren =
  {
    AuthenticatedCollectionsCollectionIdRoute:
      AuthenticatedCollectionsCollectionIdRouteWithChildren,
  }

const AuthenticatedCollectionsRouteWithChildren =
  AuthenticatedCollectionsRoute._addFileChildren(
    AuthenticatedCollectionsRouteChildren,
  )

interface AuthenticatedDocumentsRouteChildren {
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedDocumentsTemplatesNewRoute: typeof AuthenticatedDocumentsTemplatesNewRoute
  AuthenticatedDocumentsRecordsIdEditRoute: typeof AuthenticatedDocumentsRecordsIdEditRoute
  AuthenticatedDocumentsTemplatesIdEditRoute: typeof AuthenticatedDocumentsTemplatesIdEditRoute
}

const AuthenticatedDocumentsRouteChildren: AuthenticatedDocumentsRouteChildren =
  {
    AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
    AuthenticatedDocumentsTemplatesNewRoute:
      AuthenticatedDocumentsTemplatesNewRoute,
    AuthenticatedDocumentsRecordsIdEditRoute:
      AuthenticatedDocumentsRecordsIdEditRoute,
    AuthenticatedDocumentsTemplatesIdEditRoute:
      AuthenticatedDocumentsTemplatesIdEditRoute,
  }

const AuthenticatedDocumentsRouteWithChildren =
  AuthenticatedDocumentsRoute._addFileChildren(
    AuthenticatedDocumentsRouteChildren,
  )

interface AuthenticatedInvoicesRouteChildren {
  AuthenticatedInvoicesNewRoute: typeof AuthenticatedInvoicesNewRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedInvoicesIdEditRoute: typeof AuthenticatedInvoicesIdEditRoute
  AuthenticatedInvoicesCreditNotesNewRoute: typeof AuthenticatedInvoicesCreditNotesNewRoute
  AuthenticatedInvoicesDebitNotesNewRoute: typeof AuthenticatedInvoicesDebitNotesNewRoute
  AuthenticatedInvoicesCancelationsIndexRoute: typeof AuthenticatedInvoicesCancelationsIndexRoute
  AuthenticatedInvoicesCreditNotesIndexRoute: typeof AuthenticatedInvoicesCreditNotesIndexRoute
  AuthenticatedInvoicesCreditsIndexRoute: typeof AuthenticatedInvoicesCreditsIndexRoute
  AuthenticatedInvoicesDebitNotesIndexRoute: typeof AuthenticatedInvoicesDebitNotesIndexRoute
  AuthenticatedInvoicesExemptionsIndexRoute: typeof AuthenticatedInvoicesExemptionsIndexRoute
  AuthenticatedInvoicesPaymentsIndexRoute: typeof AuthenticatedInvoicesPaymentsIndexRoute
  AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute: typeof AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute
  AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute: typeof AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute
  AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute: typeof AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute
  AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute: typeof AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute
}

const AuthenticatedInvoicesRouteChildren: AuthenticatedInvoicesRouteChildren = {
  AuthenticatedInvoicesNewRoute: AuthenticatedInvoicesNewRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedInvoicesIdEditRoute: AuthenticatedInvoicesIdEditRoute,
  AuthenticatedInvoicesCreditNotesNewRoute:
    AuthenticatedInvoicesCreditNotesNewRoute,
  AuthenticatedInvoicesDebitNotesNewRoute:
    AuthenticatedInvoicesDebitNotesNewRoute,
  AuthenticatedInvoicesCancelationsIndexRoute:
    AuthenticatedInvoicesCancelationsIndexRoute,
  AuthenticatedInvoicesCreditNotesIndexRoute:
    AuthenticatedInvoicesCreditNotesIndexRoute,
  AuthenticatedInvoicesCreditsIndexRoute:
    AuthenticatedInvoicesCreditsIndexRoute,
  AuthenticatedInvoicesDebitNotesIndexRoute:
    AuthenticatedInvoicesDebitNotesIndexRoute,
  AuthenticatedInvoicesExemptionsIndexRoute:
    AuthenticatedInvoicesExemptionsIndexRoute,
  AuthenticatedInvoicesPaymentsIndexRoute:
    AuthenticatedInvoicesPaymentsIndexRoute,
  AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute:
    AuthenticatedInvoicesCreditNotesCreditNoteIdEditRoute,
  AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute:
    AuthenticatedInvoicesDebitNotesDebitNoteIdEditRoute,
  AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute:
    AuthenticatedInvoicesCreditNotesCreditNoteIdIndexRoute,
  AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute:
    AuthenticatedInvoicesDebitNotesDebitNoteIdIndexRoute,
}

const AuthenticatedInvoicesRouteWithChildren =
  AuthenticatedInvoicesRoute._addFileChildren(
    AuthenticatedInvoicesRouteChildren,
  )

interface AuthenticatedOperationsWorkOrdersListRouteChildren {
  AuthenticatedOperationsWorkOrdersListCalendarRoute: typeof AuthenticatedOperationsWorkOrdersListCalendarRoute
  AuthenticatedOperationsWorkOrdersListMineRoute: typeof AuthenticatedOperationsWorkOrdersListMineRoute
  AuthenticatedOperationsWorkOrdersListTableRoute: typeof AuthenticatedOperationsWorkOrdersListTableRoute
  AuthenticatedOperationsWorkOrdersListWeekRoute: typeof AuthenticatedOperationsWorkOrdersListWeekRoute
  AuthenticatedOperationsWorkOrdersListIndexRoute: typeof AuthenticatedOperationsWorkOrdersListIndexRoute
}

const AuthenticatedOperationsWorkOrdersListRouteChildren: AuthenticatedOperationsWorkOrdersListRouteChildren =
  {
    AuthenticatedOperationsWorkOrdersListCalendarRoute:
      AuthenticatedOperationsWorkOrdersListCalendarRoute,
    AuthenticatedOperationsWorkOrdersListMineRoute:
      AuthenticatedOperationsWorkOrdersListMineRoute,
    AuthenticatedOperationsWorkOrdersListTableRoute:
      AuthenticatedOperationsWorkOrdersListTableRoute,
    AuthenticatedOperationsWorkOrdersListWeekRoute:
      AuthenticatedOperationsWorkOrdersListWeekRoute,
    AuthenticatedOperationsWorkOrdersListIndexRoute:
      AuthenticatedOperationsWorkOrdersListIndexRoute,
  }

const AuthenticatedOperationsWorkOrdersListRouteWithChildren =
  AuthenticatedOperationsWorkOrdersListRoute._addFileChildren(
    AuthenticatedOperationsWorkOrdersListRouteChildren,
  )

interface AuthenticatedOperationsRouteChildren {
  AuthenticatedOperationsPersonnelRolesRoute: typeof AuthenticatedOperationsPersonnelRolesRoute
  AuthenticatedOperationsWorkOrdersIdRoute: typeof AuthenticatedOperationsWorkOrdersIdRoute
  AuthenticatedOperationsWorkOrdersListRoute: typeof AuthenticatedOperationsWorkOrdersListRouteWithChildren
  AuthenticatedOperationsEquipmentIndexRoute: typeof AuthenticatedOperationsEquipmentIndexRoute
  AuthenticatedOperationsPersonnelIndexRoute: typeof AuthenticatedOperationsPersonnelIndexRoute
}

const AuthenticatedOperationsRouteChildren: AuthenticatedOperationsRouteChildren =
  {
    AuthenticatedOperationsPersonnelRolesRoute:
      AuthenticatedOperationsPersonnelRolesRoute,
    AuthenticatedOperationsWorkOrdersIdRoute:
      AuthenticatedOperationsWorkOrdersIdRoute,
    AuthenticatedOperationsWorkOrdersListRoute:
      AuthenticatedOperationsWorkOrdersListRouteWithChildren,
    AuthenticatedOperationsEquipmentIndexRoute:
      AuthenticatedOperationsEquipmentIndexRoute,
    AuthenticatedOperationsPersonnelIndexRoute:
      AuthenticatedOperationsPersonnelIndexRoute,
  }

const AuthenticatedOperationsRouteWithChildren =
  AuthenticatedOperationsRoute._addFileChildren(
    AuthenticatedOperationsRouteChildren,
  )

interface AuthenticatedQuotationsRouteChildren {
  AuthenticatedQuotationsNewRoute: typeof AuthenticatedQuotationsNewRoute
  AuthenticatedQuotationsIndexRoute: typeof AuthenticatedQuotationsIndexRoute
  AuthenticatedQuotationsCodeEditRoute: typeof AuthenticatedQuotationsCodeEditRoute
}

const AuthenticatedQuotationsRouteChildren: AuthenticatedQuotationsRouteChildren =
  {
    AuthenticatedQuotationsNewRoute: AuthenticatedQuotationsNewRoute,
    AuthenticatedQuotationsIndexRoute: AuthenticatedQuotationsIndexRoute,
    AuthenticatedQuotationsCodeEditRoute: AuthenticatedQuotationsCodeEditRoute,
  }

const AuthenticatedQuotationsRouteWithChildren =
  AuthenticatedQuotationsRoute._addFileChildren(
    AuthenticatedQuotationsRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedReportsIdBuilderRoute: typeof AuthenticatedReportsIdBuilderRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedReportsIdBuilderRoute: AuthenticatedReportsIdBuilderRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSalesRouteChildren {
  AuthenticatedSalesNewRoute: typeof AuthenticatedSalesNewRoute
  AuthenticatedSalesIndexRoute: typeof AuthenticatedSalesIndexRoute
  AuthenticatedSalesIdEditRoute: typeof AuthenticatedSalesIdEditRoute
  AuthenticatedSalesSellersIndexRoute: typeof AuthenticatedSalesSellersIndexRoute
}

const AuthenticatedSalesRouteChildren: AuthenticatedSalesRouteChildren = {
  AuthenticatedSalesNewRoute: AuthenticatedSalesNewRoute,
  AuthenticatedSalesIndexRoute: AuthenticatedSalesIndexRoute,
  AuthenticatedSalesIdEditRoute: AuthenticatedSalesIdEditRoute,
  AuthenticatedSalesSellersIndexRoute: AuthenticatedSalesSellersIndexRoute,
}

const AuthenticatedSalesRouteWithChildren =
  AuthenticatedSalesRoute._addFileChildren(AuthenticatedSalesRouteChildren)

interface AuthenticatedSuppliersRouteChildren {
  AuthenticatedSuppliersIndexRoute: typeof AuthenticatedSuppliersIndexRoute
}

const AuthenticatedSuppliersRouteChildren: AuthenticatedSuppliersRouteChildren =
  {
    AuthenticatedSuppliersIndexRoute: AuthenticatedSuppliersIndexRoute,
  }

const AuthenticatedSuppliersRouteWithChildren =
  AuthenticatedSuppliersRoute._addFileChildren(
    AuthenticatedSuppliersRouteChildren,
  )

interface AuthenticatedAiLayoutRouteChildren {
  AuthenticatedAiLayoutInsightsRoute: typeof AuthenticatedAiLayoutInsightsRoute
  AuthenticatedAiLayoutIndexRoute: typeof AuthenticatedAiLayoutIndexRoute
}

const AuthenticatedAiLayoutRouteChildren: AuthenticatedAiLayoutRouteChildren = {
  AuthenticatedAiLayoutInsightsRoute: AuthenticatedAiLayoutInsightsRoute,
  AuthenticatedAiLayoutIndexRoute: AuthenticatedAiLayoutIndexRoute,
}

const AuthenticatedAiLayoutRouteWithChildren =
  AuthenticatedAiLayoutRoute._addFileChildren(
    AuthenticatedAiLayoutRouteChildren,
  )

interface AuthenticatedProductsLayoutRouteChildren {
  AuthenticatedProductsLayoutNewRoute: typeof AuthenticatedProductsLayoutNewRoute
  AuthenticatedProductsLayoutIndexRoute: typeof AuthenticatedProductsLayoutIndexRoute
  AuthenticatedProductsLayoutIdEditRoute: typeof AuthenticatedProductsLayoutIdEditRoute
}

const AuthenticatedProductsLayoutRouteChildren: AuthenticatedProductsLayoutRouteChildren =
  {
    AuthenticatedProductsLayoutNewRoute: AuthenticatedProductsLayoutNewRoute,
    AuthenticatedProductsLayoutIndexRoute:
      AuthenticatedProductsLayoutIndexRoute,
    AuthenticatedProductsLayoutIdEditRoute:
      AuthenticatedProductsLayoutIdEditRoute,
  }

const AuthenticatedProductsLayoutRouteWithChildren =
  AuthenticatedProductsLayoutRoute._addFileChildren(
    AuthenticatedProductsLayoutRouteChildren,
  )

interface AuthenticatedServicesLayoutRouteChildren {
  AuthenticatedServicesLayoutNewRoute: typeof AuthenticatedServicesLayoutNewRoute
  AuthenticatedServicesLayoutIndexRoute: typeof AuthenticatedServicesLayoutIndexRoute
  AuthenticatedServicesLayoutIdEditRoute: typeof AuthenticatedServicesLayoutIdEditRoute
}

const AuthenticatedServicesLayoutRouteChildren: AuthenticatedServicesLayoutRouteChildren =
  {
    AuthenticatedServicesLayoutNewRoute: AuthenticatedServicesLayoutNewRoute,
    AuthenticatedServicesLayoutIndexRoute:
      AuthenticatedServicesLayoutIndexRoute,
    AuthenticatedServicesLayoutIdEditRoute:
      AuthenticatedServicesLayoutIdEditRoute,
  }

const AuthenticatedServicesLayoutRouteWithChildren =
  AuthenticatedServicesLayoutRoute._addFileChildren(
    AuthenticatedServicesLayoutRouteChildren,
  )

interface AuthenticatedSettingsLayoutRouteChildren {
  AuthenticatedSettingsLayoutAiRoute: typeof AuthenticatedSettingsLayoutAiRoute
  AuthenticatedSettingsLayoutBranchesRoute: typeof AuthenticatedSettingsLayoutBranchesRoute
  AuthenticatedSettingsLayoutCatalogsRoute: typeof AuthenticatedSettingsLayoutCatalogsRoute
  AuthenticatedSettingsLayoutCompaniesRoute: typeof AuthenticatedSettingsLayoutCompaniesRoute
  AuthenticatedSettingsLayoutCorrelativesRoute: typeof AuthenticatedSettingsLayoutCorrelativesRoute
  AuthenticatedSettingsLayoutMigrationsRoute: typeof AuthenticatedSettingsLayoutMigrationsRoute
  AuthenticatedSettingsLayoutNomenclaturesRoute: typeof AuthenticatedSettingsLayoutNomenclaturesRoute
  AuthenticatedSettingsLayoutNotificationsRoute: typeof AuthenticatedSettingsLayoutNotificationsRoute
  AuthenticatedSettingsLayoutRolesRoute: typeof AuthenticatedSettingsLayoutRolesRoute
  AuthenticatedSettingsLayoutSchemaRoute: typeof AuthenticatedSettingsLayoutSchemaRoute
  AuthenticatedSettingsLayoutSecurityRoute: typeof AuthenticatedSettingsLayoutSecurityRoute
  AuthenticatedSettingsLayoutSubscriptionRoute: typeof AuthenticatedSettingsLayoutSubscriptionRoute
  AuthenticatedSettingsLayoutTrashRoute: typeof AuthenticatedSettingsLayoutTrashRoute
  AuthenticatedSettingsLayoutUsersRoute: typeof AuthenticatedSettingsLayoutUsersRoute
  AuthenticatedSettingsLayoutWarehousesRoute: typeof AuthenticatedSettingsLayoutWarehousesRoute
  AuthenticatedSettingsLayoutIndexRoute: typeof AuthenticatedSettingsLayoutIndexRoute
  AuthenticatedSettingsLayoutAppsListingIdRoute: typeof AuthenticatedSettingsLayoutAppsListingIdRoute
  AuthenticatedSettingsLayoutAppsPublishRoute: typeof AuthenticatedSettingsLayoutAppsPublishRoute
  AuthenticatedSettingsLayoutCollectionsSchemaRoute: typeof AuthenticatedSettingsLayoutCollectionsSchemaRoute
  AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute: typeof AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute
  AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute: typeof AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute
  AuthenticatedSettingsLayoutInvoicesCreditNotesRoute: typeof AuthenticatedSettingsLayoutInvoicesCreditNotesRoute
  AuthenticatedSettingsLayoutInvoicesDebitNotesRoute: typeof AuthenticatedSettingsLayoutInvoicesDebitNotesRoute
  AuthenticatedSettingsLayoutInvoicesExemptsRoute: typeof AuthenticatedSettingsLayoutInvoicesExemptsRoute
  AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute: typeof AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute
  AuthenticatedSettingsLayoutScriptsScriptIdRoute: typeof AuthenticatedSettingsLayoutScriptsScriptIdRoute
  AuthenticatedSettingsLayoutSitesSiteKeyRoute: typeof AuthenticatedSettingsLayoutSitesSiteKeyRoute
  AuthenticatedSettingsLayoutAgentsIndexRoute: typeof AuthenticatedSettingsLayoutAgentsIndexRoute
  AuthenticatedSettingsLayoutAppsIndexRoute: typeof AuthenticatedSettingsLayoutAppsIndexRoute
  AuthenticatedSettingsLayoutCollectionsIndexRoute: typeof AuthenticatedSettingsLayoutCollectionsIndexRoute
  AuthenticatedSettingsLayoutIntegrationsIndexRoute: typeof AuthenticatedSettingsLayoutIntegrationsIndexRoute
  AuthenticatedSettingsLayoutInventoryIndexRoute: typeof AuthenticatedSettingsLayoutInventoryIndexRoute
  AuthenticatedSettingsLayoutInvoicesIndexRoute: typeof AuthenticatedSettingsLayoutInvoicesIndexRoute
  AuthenticatedSettingsLayoutScriptsIndexRoute: typeof AuthenticatedSettingsLayoutScriptsIndexRoute
  AuthenticatedSettingsLayoutSitesIndexRoute: typeof AuthenticatedSettingsLayoutSitesIndexRoute
  AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute: typeof AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute
}

const AuthenticatedSettingsLayoutRouteChildren: AuthenticatedSettingsLayoutRouteChildren =
  {
    AuthenticatedSettingsLayoutAiRoute: AuthenticatedSettingsLayoutAiRoute,
    AuthenticatedSettingsLayoutBranchesRoute:
      AuthenticatedSettingsLayoutBranchesRoute,
    AuthenticatedSettingsLayoutCatalogsRoute:
      AuthenticatedSettingsLayoutCatalogsRoute,
    AuthenticatedSettingsLayoutCompaniesRoute:
      AuthenticatedSettingsLayoutCompaniesRoute,
    AuthenticatedSettingsLayoutCorrelativesRoute:
      AuthenticatedSettingsLayoutCorrelativesRoute,
    AuthenticatedSettingsLayoutMigrationsRoute:
      AuthenticatedSettingsLayoutMigrationsRoute,
    AuthenticatedSettingsLayoutNomenclaturesRoute:
      AuthenticatedSettingsLayoutNomenclaturesRoute,
    AuthenticatedSettingsLayoutNotificationsRoute:
      AuthenticatedSettingsLayoutNotificationsRoute,
    AuthenticatedSettingsLayoutRolesRoute:
      AuthenticatedSettingsLayoutRolesRoute,
    AuthenticatedSettingsLayoutSchemaRoute:
      AuthenticatedSettingsLayoutSchemaRoute,
    AuthenticatedSettingsLayoutSecurityRoute:
      AuthenticatedSettingsLayoutSecurityRoute,
    AuthenticatedSettingsLayoutSubscriptionRoute:
      AuthenticatedSettingsLayoutSubscriptionRoute,
    AuthenticatedSettingsLayoutTrashRoute:
      AuthenticatedSettingsLayoutTrashRoute,
    AuthenticatedSettingsLayoutUsersRoute:
      AuthenticatedSettingsLayoutUsersRoute,
    AuthenticatedSettingsLayoutWarehousesRoute:
      AuthenticatedSettingsLayoutWarehousesRoute,
    AuthenticatedSettingsLayoutIndexRoute:
      AuthenticatedSettingsLayoutIndexRoute,
    AuthenticatedSettingsLayoutAppsListingIdRoute:
      AuthenticatedSettingsLayoutAppsListingIdRoute,
    AuthenticatedSettingsLayoutAppsPublishRoute:
      AuthenticatedSettingsLayoutAppsPublishRoute,
    AuthenticatedSettingsLayoutCollectionsSchemaRoute:
      AuthenticatedSettingsLayoutCollectionsSchemaRoute,
    AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute:
      AuthenticatedSettingsLayoutEmailTemplatesTemplateIdRoute,
    AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute:
      AuthenticatedSettingsLayoutIntegrationsConnectionIdRoute,
    AuthenticatedSettingsLayoutInvoicesCreditNotesRoute:
      AuthenticatedSettingsLayoutInvoicesCreditNotesRoute,
    AuthenticatedSettingsLayoutInvoicesDebitNotesRoute:
      AuthenticatedSettingsLayoutInvoicesDebitNotesRoute,
    AuthenticatedSettingsLayoutInvoicesExemptsRoute:
      AuthenticatedSettingsLayoutInvoicesExemptsRoute,
    AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute:
      AuthenticatedSettingsLayoutPdfTemplatesTemplateIdRoute,
    AuthenticatedSettingsLayoutScriptsScriptIdRoute:
      AuthenticatedSettingsLayoutScriptsScriptIdRoute,
    AuthenticatedSettingsLayoutSitesSiteKeyRoute:
      AuthenticatedSettingsLayoutSitesSiteKeyRoute,
    AuthenticatedSettingsLayoutAgentsIndexRoute:
      AuthenticatedSettingsLayoutAgentsIndexRoute,
    AuthenticatedSettingsLayoutAppsIndexRoute:
      AuthenticatedSettingsLayoutAppsIndexRoute,
    AuthenticatedSettingsLayoutCollectionsIndexRoute:
      AuthenticatedSettingsLayoutCollectionsIndexRoute,
    AuthenticatedSettingsLayoutIntegrationsIndexRoute:
      AuthenticatedSettingsLayoutIntegrationsIndexRoute,
    AuthenticatedSettingsLayoutInventoryIndexRoute:
      AuthenticatedSettingsLayoutInventoryIndexRoute,
    AuthenticatedSettingsLayoutInvoicesIndexRoute:
      AuthenticatedSettingsLayoutInvoicesIndexRoute,
    AuthenticatedSettingsLayoutScriptsIndexRoute:
      AuthenticatedSettingsLayoutScriptsIndexRoute,
    AuthenticatedSettingsLayoutSitesIndexRoute:
      AuthenticatedSettingsLayoutSitesIndexRoute,
    AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute:
      AuthenticatedSettingsLayoutCollectionsConfigCollectionIdRoute,
  }

const AuthenticatedSettingsLayoutRouteWithChildren =
  AuthenticatedSettingsLayoutRoute._addFileChildren(
    AuthenticatedSettingsLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedClientsRoute: typeof AuthenticatedClientsRouteWithChildren
  AuthenticatedCollectionsRoute: typeof AuthenticatedCollectionsRouteWithChildren
  AuthenticatedCompleteProfileRoute: typeof AuthenticatedCompleteProfileRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRouteWithChildren
  AuthenticatedInvoicesRoute: typeof AuthenticatedInvoicesRouteWithChildren
  AuthenticatedOperationsRoute: typeof AuthenticatedOperationsRouteWithChildren
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedQuotationsRoute: typeof AuthenticatedQuotationsRouteWithChildren
  AuthenticatedReleaseNotesRoute: typeof AuthenticatedReleaseNotesRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSalesRoute: typeof AuthenticatedSalesRouteWithChildren
  AuthenticatedSubscriptionSuccessRoute: typeof AuthenticatedSubscriptionSuccessRoute
  AuthenticatedSubscriptionsRoute: typeof AuthenticatedSubscriptionsRoute
  AuthenticatedSuppliersRoute: typeof AuthenticatedSuppliersRouteWithChildren
  AuthenticatedDevCrdtPlaygroundRoute: typeof AuthenticatedDevCrdtPlaygroundRoute
  AuthenticatedAiLayoutRoute: typeof AuthenticatedAiLayoutRouteWithChildren
  AuthenticatedInventoryCountsNewRoute: typeof AuthenticatedInventoryCountsNewRoute
  AuthenticatedInventoryMovementsRoute: typeof AuthenticatedInventoryMovementsRoute
  AuthenticatedProductsLayoutRoute: typeof AuthenticatedProductsLayoutRouteWithChildren
  AuthenticatedPurchaseOrdersNewRoute: typeof AuthenticatedPurchaseOrdersNewRoute
  AuthenticatedServicesLayoutRoute: typeof AuthenticatedServicesLayoutRouteWithChildren
  AuthenticatedSettingsLayoutRoute: typeof AuthenticatedSettingsLayoutRouteWithChildren
  AuthenticatedStockTransfersNewRoute: typeof AuthenticatedStockTransfersNewRoute
  AuthenticatedInventoryCountsIndexRoute: typeof AuthenticatedInventoryCountsIndexRoute
  AuthenticatedInventoryIndexRoute: typeof AuthenticatedInventoryIndexRoute
  AuthenticatedPurchaseOrdersIndexRoute: typeof AuthenticatedPurchaseOrdersIndexRoute
  AuthenticatedStockTransfersIndexRoute: typeof AuthenticatedStockTransfersIndexRoute
  AuthenticatedInventoryCountsIdEditRoute: typeof AuthenticatedInventoryCountsIdEditRoute
  AuthenticatedPurchaseOrdersIdEditRoute: typeof AuthenticatedPurchaseOrdersIdEditRoute
  AuthenticatedStockTransfersIdEditRoute: typeof AuthenticatedStockTransfersIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedClientsRoute: AuthenticatedClientsRouteWithChildren,
  AuthenticatedCollectionsRoute: AuthenticatedCollectionsRouteWithChildren,
  AuthenticatedCompleteProfileRoute: AuthenticatedCompleteProfileRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRouteWithChildren,
  AuthenticatedInvoicesRoute: AuthenticatedInvoicesRouteWithChildren,
  AuthenticatedOperationsRoute: AuthenticatedOperationsRouteWithChildren,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedQuotationsRoute: AuthenticatedQuotationsRouteWithChildren,
  AuthenticatedReleaseNotesRoute: AuthenticatedReleaseNotesRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSalesRoute: AuthenticatedSalesRouteWithChildren,
  AuthenticatedSubscriptionSuccessRoute: AuthenticatedSubscriptionSuccessRoute,
  AuthenticatedSubscriptionsRoute: AuthenticatedSubscriptionsRoute,
  AuthenticatedSuppliersRoute: AuthenticatedSuppliersRouteWithChildren,
  AuthenticatedDevCrdtPlaygroundRoute: AuthenticatedDevCrdtPlaygroundRoute,
  AuthenticatedAiLayoutRoute: AuthenticatedAiLayoutRouteWithChildren,
  AuthenticatedInventoryCountsNewRoute: AuthenticatedInventoryCountsNewRoute,
  AuthenticatedInventoryMovementsRoute: AuthenticatedInventoryMovementsRoute,
  AuthenticatedProductsLayoutRoute:
    AuthenticatedProductsLayoutRouteWithChildren,
  AuthenticatedPurchaseOrdersNewRoute: AuthenticatedPurchaseOrdersNewRoute,
  AuthenticatedServicesLayoutRoute:
    AuthenticatedServicesLayoutRouteWithChildren,
  AuthenticatedSettingsLayoutRoute:
    AuthenticatedSettingsLayoutRouteWithChildren,
  AuthenticatedStockTransfersNewRoute: AuthenticatedStockTransfersNewRoute,
  AuthenticatedInventoryCountsIndexRoute:
    AuthenticatedInventoryCountsIndexRoute,
  AuthenticatedInventoryIndexRoute: AuthenticatedInventoryIndexRoute,
  AuthenticatedPurchaseOrdersIndexRoute: AuthenticatedPurchaseOrdersIndexRoute,
  AuthenticatedStockTransfersIndexRoute: AuthenticatedStockTransfersIndexRoute,
  AuthenticatedInventoryCountsIdEditRoute:
    AuthenticatedInventoryCountsIdEditRoute,
  AuthenticatedPurchaseOrdersIdEditRoute:
    AuthenticatedPurchaseOrdersIdEditRoute,
  AuthenticatedStockTransfersIdEditRoute:
    AuthenticatedStockTransfersIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface HomeRouteChildren {
  HomeWaitlistRoute: typeof HomeWaitlistRoute
  HomeIndexRoute: typeof HomeIndexRoute
}

const HomeRouteChildren: HomeRouteChildren = {
  HomeWaitlistRoute: HomeWaitlistRoute,
  HomeIndexRoute: HomeIndexRoute,
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)

interface PublicRouteChildren {
  PublicActivateRoute: typeof PublicActivateRoute
  PublicLicensesRoute: typeof PublicLicensesRoute
  PublicSetupRoute: typeof PublicSetupRoute
  PublicAuthFirstTimeLoginRoute: typeof PublicAuthFirstTimeLoginRoute
  PublicAuthResetPasswordRoute: typeof PublicAuthResetPasswordRoute
  PublicAuthSignInRoute: typeof PublicAuthSignInRoute
  PublicAuthSignInWithOtpRoute: typeof PublicAuthSignInWithOtpRoute
  PublicAuthSignUpRoute: typeof PublicAuthSignUpRoute
  PublicSSlugPageRoute: typeof PublicSSlugPageRoute
  PublicSharedDashboardsTokenRoute: typeof PublicSharedDashboardsTokenRoute
  PublicSharedInvoicesIdRoute: typeof PublicSharedInvoicesIdRoute
  PublicSharedQuotationsIdRoute: typeof PublicSharedQuotationsIdRoute
  PublicSharedSalesIdRoute: typeof PublicSharedSalesIdRoute
  PublicSSlugIndexRoute: typeof PublicSSlugIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicActivateRoute: PublicActivateRoute,
  PublicLicensesRoute: PublicLicensesRoute,
  PublicSetupRoute: PublicSetupRoute,
  PublicAuthFirstTimeLoginRoute: PublicAuthFirstTimeLoginRoute,
  PublicAuthResetPasswordRoute: PublicAuthResetPasswordRoute,
  PublicAuthSignInRoute: PublicAuthSignInRoute,
  PublicAuthSignInWithOtpRoute: PublicAuthSignInWithOtpRoute,
  PublicAuthSignUpRoute: PublicAuthSignUpRoute,
  PublicSSlugPageRoute: PublicSSlugPageRoute,
  PublicSharedDashboardsTokenRoute: PublicSharedDashboardsTokenRoute,
  PublicSharedInvoicesIdRoute: PublicSharedInvoicesIdRoute,
  PublicSharedQuotationsIdRoute: PublicSharedQuotationsIdRoute,
  PublicSharedSalesIdRoute: PublicSharedSalesIdRoute,
  PublicSSlugIndexRoute: PublicSSlugIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface SuperSuperControlPanelCompanyIdRouteChildren {
  SuperSuperControlPanelCompanyIdHistoryRoute: typeof SuperSuperControlPanelCompanyIdHistoryRoute
  SuperSuperControlPanelCompanyIdOverviewRoute: typeof SuperSuperControlPanelCompanyIdOverviewRoute
  SuperSuperControlPanelCompanyIdSubscriptionRoute: typeof SuperSuperControlPanelCompanyIdSubscriptionRoute
  SuperSuperControlPanelCompanyIdUsageRoute: typeof SuperSuperControlPanelCompanyIdUsageRoute
  SuperSuperControlPanelCompanyIdUsersRoute: typeof SuperSuperControlPanelCompanyIdUsersRoute
}

const SuperSuperControlPanelCompanyIdRouteChildren: SuperSuperControlPanelCompanyIdRouteChildren =
  {
    SuperSuperControlPanelCompanyIdHistoryRoute:
      SuperSuperControlPanelCompanyIdHistoryRoute,
    SuperSuperControlPanelCompanyIdOverviewRoute:
      SuperSuperControlPanelCompanyIdOverviewRoute,
    SuperSuperControlPanelCompanyIdSubscriptionRoute:
      SuperSuperControlPanelCompanyIdSubscriptionRoute,
    SuperSuperControlPanelCompanyIdUsageRoute:
      SuperSuperControlPanelCompanyIdUsageRoute,
    SuperSuperControlPanelCompanyIdUsersRoute:
      SuperSuperControlPanelCompanyIdUsersRoute,
  }

const SuperSuperControlPanelCompanyIdRouteWithChildren =
  SuperSuperControlPanelCompanyIdRoute._addFileChildren(
    SuperSuperControlPanelCompanyIdRouteChildren,
  )

interface SuperRouteChildren {
  SuperSuperLayoutRoute: typeof SuperSuperLayoutRoute
  SuperSuperCompaniesRoute: typeof SuperSuperCompaniesRoute
  SuperSuperDashboardRoute: typeof SuperSuperDashboardRoute
  SuperSuperLicensesRoute: typeof SuperSuperLicensesRoute
  SuperSuperPlansRoute: typeof SuperSuperPlansRoute
  SuperSuperReleasesRoute: typeof SuperSuperReleasesRoute
  SuperSuperSubscriptionsRoute: typeof SuperSuperSubscriptionsRoute
  SuperSuperUsersRoute: typeof SuperSuperUsersRoute
  SuperSuperWaitlistRoute: typeof SuperSuperWaitlistRoute
  SuperSuperAppsVersionIdRoute: typeof SuperSuperAppsVersionIdRoute
  SuperSuperControlPanelCompanyIdRoute: typeof SuperSuperControlPanelCompanyIdRouteWithChildren
  SuperSuperAppsIndexRoute: typeof SuperSuperAppsIndexRoute
}

const SuperRouteChildren: SuperRouteChildren = {
  SuperSuperLayoutRoute: SuperSuperLayoutRoute,
  SuperSuperCompaniesRoute: SuperSuperCompaniesRoute,
  SuperSuperDashboardRoute: SuperSuperDashboardRoute,
  SuperSuperLicensesRoute: SuperSuperLicensesRoute,
  SuperSuperPlansRoute: SuperSuperPlansRoute,
  SuperSuperReleasesRoute: SuperSuperReleasesRoute,
  SuperSuperSubscriptionsRoute: SuperSuperSubscriptionsRoute,
  SuperSuperUsersRoute: SuperSuperUsersRoute,
  SuperSuperWaitlistRoute: SuperSuperWaitlistRoute,
  SuperSuperAppsVersionIdRoute: SuperSuperAppsVersionIdRoute,
  SuperSuperControlPanelCompanyIdRoute:
    SuperSuperControlPanelCompanyIdRouteWithChildren,
  SuperSuperAppsIndexRoute: SuperSuperAppsIndexRoute,
}

const SuperRouteWithChildren = SuperRoute._addFileChildren(SuperRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  HomeRoute: HomeRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SuperRoute: SuperRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
